import { defineTranslations, type TranslationRecord } from "@festina-life/core"

import type { enConfiguredEnums, enEnums } from "./enum.en"

export const dkEnums = defineTranslations<TranslationRecord<typeof enEnums>>()({
  "collCalc.enum.AccountType.none": "Ingen",
  "collCalc.enum.AccountType.rounding": "",
  "collCalc.enum.BatchStatusType.completed": "",
  "collCalc.enum.BatchStatusType.created": "",
  "collCalc.enum.BatchStatusType.failed": "",
  "collCalc.enum.BatchStatusType.started": "",
  "collCalc.enum.BatchStatusType.stopped": "",
  "collCalc.enum.BulkDataType.Accounts": "",
  "collCalc.enum.BulkDataType.BalancePostings": "",
  "collCalc.enum.BulkDataType.Enums": "",
  "collCalc.enum.BulkDataType.OpenPostPostings": "",
  "collCalc.enum.BulkDataType.ParameterValueIntervals": "",
  "collCalc.enum.BulkDataType.ParameterValues": "",
  "collCalc.enum.BulkDataType.TariffTemplates": "",
  "collCalc.enum.BulkDataType.Tenants": "",
  "collCalc.enum.BulkDataType.WorkPads": "",
  "collCalc.enum.BusinessType.company": "",
  "collCalc.enum.BusinessType.person": "",
  "collCalc.enum.CcCalcType.monthly": "Månedligt",
  "collCalc.enum.CcCalcType.yearly": "Årligt",
  "collCalc.enum.CcGroupType.ageMonths": "",
  "collCalc.enum.CcGroupType.ageYears": "",
  "collCalc.enum.CcInputType.x": "",
  "collCalc.enum.CcStateStatus.calculated": "Beregnet",
  "collCalc.enum.CcStateStatus.failed": "Fejlet",
  "collCalc.enum.CcStateStatus.invalid": "Ugyldig",
  "collCalc.enum.CcStateStatus.succeeded": "Fuldført",
  "collCalc.enum.CcStateStatus.superseded": "Erstattet",
  "collCalc.enum.CcStateStatus.waiting": "Afventer",
  "collCalc.enum.CommandGroupType.advance": "",
  "collCalc.enum.CommandGroupType.annotation": "",
  "collCalc.enum.CommandGroupType.calculation": "",
  "collCalc.enum.CommandGroupType.employerAgreement": "",
  "collCalc.enum.CommandGroupType.employment": "",
  "collCalc.enum.CommandGroupType.legalEntity": "",
  "collCalc.enum.CommandGroupType.moneyIn": "",
  "collCalc.enum.CommandGroupType.moneyOut": "",
  "collCalc.enum.CommandGroupType.none": "",
  "collCalc.enum.CommandGroupType.policyChange": "",
  "collCalc.enum.CommandGroupType.posting": "",
  "collCalc.enum.CommandGroupType.tax": "",
  "collCalc.enum.CommandGroupType.unitlink": "",
  "collCalc.enum.CommandType.addAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.amendAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.defaultTemplate": "",
  "collCalc.enum.CommandType.removeAccessGroupAnnotation": "",
  "collCalc.enum.ConfigurationEntityType.EnumDefinition": "",
  "collCalc.enum.ConfigurationEntityType.EnumLiteral": "",
  "collCalc.enum.ConfigurationEntityType.GlMap": "",
  "collCalc.enum.ConfigurationEntityType.ParameterDefinition": "",
  "collCalc.enum.ConfigurationEntityType.ParameterValue": "",
  "collCalc.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "collCalc.enum.ConfigurationEntityType.RegisteredTenant": "",
  "collCalc.enum.ConfigurationEntityType.Template": "",
  "collCalc.enum.DataSubscriptionRoleType.unspecified": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.deleted": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.processed": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.registered": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.rejected": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.sent": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.unsent": "",
  "collCalc.enum.ExternalPayloadReceiver.collcalc": "",
  "collCalc.enum.ExternalPayloadReceiver.datamart2": "",
  "collCalc.enum.ExternalPayloadReceiver.external": "",
  "collCalc.enum.ExternalPayloadReceiver.legalentity": "",
  "collCalc.enum.ExternalPayloadReceiver.life": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyin": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyout": "",
  "collCalc.enum.ExternalPayloadReceiver.unitlink": "",
  "collCalc.enum.ExternalPayloadType.bulkDataExport": "",
  "collCalc.enum.ExternalPayloadType.camt53": "",
  "collCalc.enum.ExternalPayloadType.camt53Returns": "",
  "collCalc.enum.ExternalPayloadType.camt54": "",
  "collCalc.enum.ExternalPayloadType.generalLedger": "",
  "collCalc.enum.ExternalPayloadType.migration": "",
  "collCalc.enum.ExternalPayloadType.namingResponse": "",
  "collCalc.enum.ExternalPayloadType.none": "Ingen",
  "collCalc.enum.ExternalPayloadType.pain001": "",
  "collCalc.enum.ExternalPayloadType.pain002": "",
  "collCalc.enum.ExternalPayloadType.testTransactionalIn": "",
  "collCalc.enum.ExternalPayloadType.testTransactionalOut": "",
  "collCalc.enum.ExternalPayloadType.testin": "",
  "collCalc.enum.ExternalPayloadType.testout": "",
  "collCalc.enum.FPlusCompletionItemTag.deprecated": "",
  "collCalc.enum.Gender.Female": "",
  "collCalc.enum.Gender.Male": "",
  "collCalc.enum.Gender.Unknown": "",
  "collCalc.enum.GlAggregationType.correction": "",
  "collCalc.enum.GlAggregationType.counter": "",
  "collCalc.enum.GlAggregationType.manual": "",
  "collCalc.enum.GlAggregationType.normal": "",
  "collCalc.enum.LogLevel.all": "",
  "collCalc.enum.LogLevel.debug": "",
  "collCalc.enum.LogLevel.error": "",
  "collCalc.enum.LogLevel.info": "",
  "collCalc.enum.LogLevel.off": "",
  "collCalc.enum.LogLevel.trace": "",
  "collCalc.enum.LogLevel.warn": "",
  "collCalc.enum.MetaAssociationOutput.aggregation": "",
  "collCalc.enum.MetaAssociationOutput.composition": "",
  "collCalc.enum.MetaCardinalityOutput.many": "",
  "collCalc.enum.MetaCardinalityOutput.one": "",
  "collCalc.enum.PostingTable.BP": "",
  "collCalc.enum.PostingTable.OPP": "",
  "collCalc.enum.PostingType.glRounding": "",
  "collCalc.enum.PostingType.glRoundingExcluded": "",
  "collCalc.enum.PostingType.none": "Ingen",
  "collCalc.enum.ReportType.none": "Ingen",
  "collCalc.enum.ReportingEventType.cancelled": "",
  "collCalc.enum.ReportingEventType.newReport": "",
  "collCalc.enum.ReportingEventType.reported": "",
  "collCalc.enum.ReportingEventType.update": "",
  "collCalc.enum.Step.x": "",
  "collCalc.enum.StepValueType.number": "",
  "collCalc.enum.StepValueType.percent": "",
  "collCalc.enum.TenantSubGroup.none": "Ingen",
  "collCalc.enum.TestBatchSpecificationType.faulty": "",
  "collCalc.enum.TestBatchSpecificationType.noop": "",
  "collCalc.enum.TestBatchSpecificationType.normal": "",
  "dataMart.enum.AccountType.none": "",
  "dataMart.enum.BatchStatusType.completed": "",
  "dataMart.enum.BatchStatusType.created": "",
  "dataMart.enum.BatchStatusType.failed": "",
  "dataMart.enum.BatchStatusType.started": "",
  "dataMart.enum.BatchStatusType.stopped": "",
  "dataMart.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart.enum.ConfigurationEntityType.GlMap": "",
  "dataMart.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart.enum.ConfigurationEntityType.Template": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart.enum.ExternalPayloadReceiver.external": "",
  "dataMart.enum.ExternalPayloadType.generalLedger": "",
  "dataMart.enum.ExternalPayloadType.none": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart.enum.ExternalPayloadType.testin": "",
  "dataMart.enum.ExternalPayloadType.testout": "",
  "dataMart.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart.enum.GlAggregationType.correction": "",
  "dataMart.enum.GlAggregationType.counter": "",
  "dataMart.enum.GlAggregationType.manual": "",
  "dataMart.enum.GlAggregationType.normal": "",
  "dataMart.enum.LogLevel.all": "",
  "dataMart.enum.LogLevel.debug": "",
  "dataMart.enum.LogLevel.error": "",
  "dataMart.enum.LogLevel.info": "",
  "dataMart.enum.LogLevel.off": "",
  "dataMart.enum.LogLevel.trace": "",
  "dataMart.enum.LogLevel.warn": "",
  "dataMart.enum.MetaAssociationOutput.aggregation": "",
  "dataMart.enum.MetaAssociationOutput.composition": "",
  "dataMart.enum.MetaCardinalityOutput.many": "",
  "dataMart.enum.MetaCardinalityOutput.one": "",
  "dataMart.enum.PostingTable.BP": "",
  "dataMart.enum.PostingTable.OPP": "",
  "dataMart.enum.PostingType.none": "",
  "dataMart.enum.TestBatchSpecificationType.faulty": "",
  "dataMart.enum.TestBatchSpecificationType.noop": "",
  "dataMart.enum.TestBatchSpecificationType.normal": "",
  "dataMart2.enum.AccountType.none": "",
  "dataMart2.enum.AccountType.rounding": "",
  "dataMart2.enum.BatchStatusType.completed": "",
  "dataMart2.enum.BatchStatusType.created": "",
  "dataMart2.enum.BatchStatusType.failed": "",
  "dataMart2.enum.BatchStatusType.started": "",
  "dataMart2.enum.BatchStatusType.stopped": "",
  "dataMart2.enum.BulkDataType.Accounts": "",
  "dataMart2.enum.BulkDataType.BalancePostings": "",
  "dataMart2.enum.BulkDataType.Enums": "",
  "dataMart2.enum.BulkDataType.OpenPostPostings": "",
  "dataMart2.enum.BulkDataType.ParameterValueIntervals": "",
  "dataMart2.enum.BulkDataType.ParameterValues": "",
  "dataMart2.enum.BulkDataType.TariffTemplates": "",
  "dataMart2.enum.BulkDataType.Tenants": "",
  "dataMart2.enum.BulkDataType.WorkPads": "",
  "dataMart2.enum.BusinessType.company": "",
  "dataMart2.enum.BusinessType.person": "",
  "dataMart2.enum.CommandGroupType.advance": "",
  "dataMart2.enum.CommandGroupType.annotation": "",
  "dataMart2.enum.CommandGroupType.calculation": "",
  "dataMart2.enum.CommandGroupType.employerAgreement": "",
  "dataMart2.enum.CommandGroupType.employment": "",
  "dataMart2.enum.CommandGroupType.legalEntity": "",
  "dataMart2.enum.CommandGroupType.moneyIn": "",
  "dataMart2.enum.CommandGroupType.moneyOut": "",
  "dataMart2.enum.CommandGroupType.none": "",
  "dataMart2.enum.CommandGroupType.policyChange": "",
  "dataMart2.enum.CommandGroupType.posting": "",
  "dataMart2.enum.CommandGroupType.tax": "",
  "dataMart2.enum.CommandGroupType.unitlink": "",
  "dataMart2.enum.CommandType.addAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.amendAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.defaultTemplate": "",
  "dataMart2.enum.CommandType.removeAccessGroupAnnotation": "",
  "dataMart2.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart2.enum.ConfigurationEntityType.GlMap": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart2.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart2.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart2.enum.ConfigurationEntityType.Template": "",
  "dataMart2.enum.DataSubscriptionRoleType.unspecified": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart2.enum.ExternalPayloadReceiver.collcalc": "",
  "dataMart2.enum.ExternalPayloadReceiver.datamart2": "",
  "dataMart2.enum.ExternalPayloadReceiver.external": "",
  "dataMart2.enum.ExternalPayloadReceiver.legalentity": "",
  "dataMart2.enum.ExternalPayloadReceiver.life": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyin": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyout": "",
  "dataMart2.enum.ExternalPayloadReceiver.unitlink": "",
  "dataMart2.enum.ExternalPayloadType.bulkDataExport": "",
  "dataMart2.enum.ExternalPayloadType.camt53": "",
  "dataMart2.enum.ExternalPayloadType.camt53Returns": "",
  "dataMart2.enum.ExternalPayloadType.camt54": "",
  "dataMart2.enum.ExternalPayloadType.generalLedger": "",
  "dataMart2.enum.ExternalPayloadType.migration": "",
  "dataMart2.enum.ExternalPayloadType.namingResponse": "",
  "dataMart2.enum.ExternalPayloadType.none": "",
  "dataMart2.enum.ExternalPayloadType.pain001": "",
  "dataMart2.enum.ExternalPayloadType.pain002": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart2.enum.ExternalPayloadType.testin": "",
  "dataMart2.enum.ExternalPayloadType.testout": "",
  "dataMart2.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart2.enum.Gender.Female": "",
  "dataMart2.enum.Gender.Male": "",
  "dataMart2.enum.Gender.Unknown": "",
  "dataMart2.enum.GlAggregationType.correction": "",
  "dataMart2.enum.GlAggregationType.counter": "",
  "dataMart2.enum.GlAggregationType.manual": "",
  "dataMart2.enum.GlAggregationType.normal": "",
  "dataMart2.enum.LogLevel.all": "",
  "dataMart2.enum.LogLevel.debug": "",
  "dataMart2.enum.LogLevel.error": "",
  "dataMart2.enum.LogLevel.info": "",
  "dataMart2.enum.LogLevel.off": "",
  "dataMart2.enum.LogLevel.trace": "",
  "dataMart2.enum.LogLevel.warn": "",
  "dataMart2.enum.MetaAssociationOutput.aggregation": "",
  "dataMart2.enum.MetaAssociationOutput.composition": "",
  "dataMart2.enum.MetaCardinalityOutput.many": "",
  "dataMart2.enum.MetaCardinalityOutput.one": "",
  "dataMart2.enum.PostingTable.BP": "",
  "dataMart2.enum.PostingTable.OPP": "",
  "dataMart2.enum.PostingType.glRounding": "",
  "dataMart2.enum.PostingType.glRoundingExcluded": "",
  "dataMart2.enum.PostingType.none": "",
  "dataMart2.enum.ReconciliationResultStatus.ACCEPTED": "",
  "dataMart2.enum.ReconciliationResultStatus.MATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.MISMATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.PENDING": "",
  "dataMart2.enum.ReportType.none": "",
  "dataMart2.enum.ReportingEventType.cancelled": "",
  "dataMart2.enum.ReportingEventType.newReport": "",
  "dataMart2.enum.ReportingEventType.reported": "",
  "dataMart2.enum.ReportingEventType.update": "",
  "dataMart2.enum.TestBatchSpecificationType.faulty": "",
  "dataMart2.enum.TestBatchSpecificationType.noop": "",
  "dataMart2.enum.TestBatchSpecificationType.normal": "",
  "legalEntity.enum.AccountType.none": "Ingen",
  "legalEntity.enum.AccountType.rounding": "",
  "legalEntity.enum.AddressType.formal": "Formel",
  "legalEntity.enum.AddressType.informal": "Uformel",
  "legalEntity.enum.AddressTypeMigrationV1Data.formal": "",
  "legalEntity.enum.AddressTypeMigrationV1Data.informal": "",
  "legalEntity.enum.BatchStatusType.completed": "Fuldført",
  "legalEntity.enum.BatchStatusType.created": "Oprettet",
  "legalEntity.enum.BatchStatusType.failed": "Fejlet",
  "legalEntity.enum.BatchStatusType.started": "Startet",
  "legalEntity.enum.BatchStatusType.stopped": "Stoppet",
  "legalEntity.enum.BulkDataType.Accounts": "",
  "legalEntity.enum.BulkDataType.BalancePostings": "",
  "legalEntity.enum.BulkDataType.Enums": "",
  "legalEntity.enum.BulkDataType.OpenPostPostings": "",
  "legalEntity.enum.BulkDataType.ParameterValueIntervals": "",
  "legalEntity.enum.BulkDataType.ParameterValues": "",
  "legalEntity.enum.BulkDataType.TariffTemplates": "",
  "legalEntity.enum.BulkDataType.Tenants": "",
  "legalEntity.enum.BulkDataType.WorkPads": "",
  "legalEntity.enum.BusinessType.company": "",
  "legalEntity.enum.BusinessType.person": "",
  "legalEntity.enum.CommandGroupType.advance": "",
  "legalEntity.enum.CommandGroupType.annotation": "",
  "legalEntity.enum.CommandGroupType.calculation": "",
  "legalEntity.enum.CommandGroupType.employerAgreement": "",
  "legalEntity.enum.CommandGroupType.employment": "",
  "legalEntity.enum.CommandGroupType.legalEntity": "",
  "legalEntity.enum.CommandGroupType.moneyIn": "",
  "legalEntity.enum.CommandGroupType.moneyOut": "",
  "legalEntity.enum.CommandGroupType.none": "Ingen",
  "legalEntity.enum.CommandGroupType.policyChange": "",
  "legalEntity.enum.CommandGroupType.posting": "",
  "legalEntity.enum.CommandGroupType.tax": "",
  "legalEntity.enum.CommandGroupType.unitlink": "",
  "legalEntity.enum.CommandType.addAccessGroupAnnotation": "Tilføj adgangsgruppeannotering",
  "legalEntity.enum.CommandType.addEmployeeName": "Tilføj medarbejder navn",
  "legalEntity.enum.CommandType.addressChange": "Adresseændring",
  "legalEntity.enum.CommandType.amendAccessGroupAnnotation": "Ændr adgangsgruppeannotering",
  "legalEntity.enum.CommandType.birthDateChange": "Skift fødselsdato",
  "legalEntity.enum.CommandType.changeLegalEntity": "Skift juridisk enhed",
  "legalEntity.enum.CommandType.companyExternalIdChange": "Virksomhed eksternt ID ændring",
  "legalEntity.enum.CommandType.createCompany": "Ny virksomhed",
  "legalEntity.enum.CommandType.createMigrationPartnerV3": "Migration partner",
  "legalEntity.enum.CommandType.createMigrationPartnerV4": "Migration partner",
  "legalEntity.enum.CommandType.createMigrationPartnersV2": "Migration partnere",
  "legalEntity.enum.CommandType.createPerson": "Ny person",
  "legalEntity.enum.CommandType.createPersonMigrationV3": "Migration person",
  "legalEntity.enum.CommandType.createPersonMigrationV4": "Migration person",
  "legalEntity.enum.CommandType.createPersonMigrationV5": "Migration person",
  "legalEntity.enum.CommandType.defaultTemplate": "Standard skabelon",
  "legalEntity.enum.CommandType.deleteAddress": "Slet adresse",
  "legalEntity.enum.CommandType.endPartnership": "Slut partnerskab",
  "legalEntity.enum.CommandType.externalIdChange": "Skift eksternt ID",
  "legalEntity.enum.CommandType.genderChange": "Skift køn",
  "legalEntity.enum.CommandType.partnerBirthdateChange": "Skift partners fødselsdato",
  "legalEntity.enum.CommandType.partnerDeceased": "Partner afdød",
  "legalEntity.enum.CommandType.partnerIdChange": "Skift partner-ID",
  "legalEntity.enum.CommandType.partnerNameChange": "Skift partners navn",
  "legalEntity.enum.CommandType.personDeceased": "Person afdød",
  "legalEntity.enum.CommandType.personNameChange": "Navneskift",
  "legalEntity.enum.CommandType.personRelocation": "Person flytning",
  "legalEntity.enum.CommandType.pointOfContactChange": "Skift kontaktpunkt",
  "legalEntity.enum.CommandType.removeAccessGroupAnnotation": "Fjern adgangsgruppeannotering",
  "legalEntity.enum.CommandType.rollback": "Tilbagerulning",
  "legalEntity.enum.CommandType.setPersonState": "Sæt persons tilstand",
  "legalEntity.enum.CommandType.singleAddressChange": "Adresseændring",
  "legalEntity.enum.CommandType.startPartnership": "Start partnerskab",
  "legalEntity.enum.CommandType.updateCommunicationPreference": "Opdater kommunikationspræference",
  "legalEntity.enum.CommandType.updateCompany": "Opdater virksomhed",
  "legalEntity.enum.CommandType.updateCompanyName": "Opdater virksomhedsnavn",
  "legalEntity.enum.CommandType.updatePartnership": "Opdater partnerskab",
  "legalEntity.enum.CommandType.updatePerson": "Opdater person",
  "legalEntity.enum.CommunicationPreferenceType.digital": "Digital",
  "legalEntity.enum.CommunicationPreferenceType.post": "Post",
  "legalEntity.enum.Component.caseHandler": "",
  "legalEntity.enum.Component.legalEntity": "",
  "legalEntity.enum.Component.life": "",
  "legalEntity.enum.Component.moneyIn": "",
  "legalEntity.enum.Component.moneyOut": "",
  "legalEntity.enum.Component.unitlink": "",
  "legalEntity.enum.ConfigurationEntityType.EnumDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.EnumLiteral": "",
  "legalEntity.enum.ConfigurationEntityType.GlMap": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterValue": "",
  "legalEntity.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "legalEntity.enum.ConfigurationEntityType.RegisteredTenant": "",
  "legalEntity.enum.ConfigurationEntityType.Template": "",
  "legalEntity.enum.DataSubscriptionRoleType.unspecified": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.deleted": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.processed": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.registered": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.rejected": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.sent": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.unsent": "",
  "legalEntity.enum.ExternalPayloadReceiver.collcalc": "",
  "legalEntity.enum.ExternalPayloadReceiver.datamart2": "",
  "legalEntity.enum.ExternalPayloadReceiver.external": "",
  "legalEntity.enum.ExternalPayloadReceiver.legalentity": "",
  "legalEntity.enum.ExternalPayloadReceiver.life": "",
  "legalEntity.enum.ExternalPayloadReceiver.moneyin": "",
  "legalEntity.enum.ExternalPayloadReceiver.moneyout": "",
  "legalEntity.enum.ExternalPayloadReceiver.unitlink": "",
  "legalEntity.enum.ExternalPayloadType.bs601BillingExt": "",
  "legalEntity.enum.ExternalPayloadType.bulkDataExport": "",
  "legalEntity.enum.ExternalPayloadType.camt53": "",
  "legalEntity.enum.ExternalPayloadType.camt53Ext": "",
  "legalEntity.enum.ExternalPayloadType.camt53Returns": "",
  "legalEntity.enum.ExternalPayloadType.camt53ReturnsExt": "",
  "legalEntity.enum.ExternalPayloadType.camt54": "",
  "legalEntity.enum.ExternalPayloadType.camt54Ext": "",
  "legalEntity.enum.ExternalPayloadType.eIndkomstExt": "",
  "legalEntity.enum.ExternalPayloadType.eIndkomstReceiptExt": "",
  "legalEntity.enum.ExternalPayloadType.generalLedger": "",
  "legalEntity.enum.ExternalPayloadType.legalEntityRecordsFile": "",
  "legalEntity.enum.ExternalPayloadType.migration": "",
  "legalEntity.enum.ExternalPayloadType.namingResponse": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataRequestExt": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataResponseExt": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingRequestExt": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingResponseExt": "",
  "legalEntity.enum.ExternalPayloadType.none": "Ingen",
  "legalEntity.enum.ExternalPayloadType.pain001": "",
  "legalEntity.enum.ExternalPayloadType.pain001Ext": "",
  "legalEntity.enum.ExternalPayloadType.pain002": "",
  "legalEntity.enum.ExternalPayloadType.pain002Ext": "",
  "legalEntity.enum.ExternalPayloadType.personRegistrySubscriptionOutExt": "",
  "legalEntity.enum.ExternalPayloadType.testTransactionalIn": "",
  "legalEntity.enum.ExternalPayloadType.testTransactionalOut": "",
  "legalEntity.enum.ExternalPayloadType.testin": "",
  "legalEntity.enum.ExternalPayloadType.testout": "",
  "legalEntity.enum.FPlusCompletionItemTag.deprecated": "",
  "legalEntity.enum.Gender.Female": "Kvinde",
  "legalEntity.enum.Gender.Male": "Mand",
  "legalEntity.enum.Gender.Unknown": "Ukendt",
  "legalEntity.enum.GenderMigrationV1Data.female": "",
  "legalEntity.enum.GenderMigrationV1Data.male": "",
  "legalEntity.enum.GenderMigrationV1Data.unknown": "",
  "legalEntity.enum.GlAggregationType.correction": "",
  "legalEntity.enum.GlAggregationType.counter": "",
  "legalEntity.enum.GlAggregationType.manual": "",
  "legalEntity.enum.GlAggregationType.normal": "",
  "legalEntity.enum.IdentityType.external": "Ekstern",
  "legalEntity.enum.IdentityType.internal": "Intern",
  "legalEntity.enum.InformationSource.employer": "Arbejdsgiver",
  "legalEntity.enum.InformationSource.migration": "Migrering",
  "legalEntity.enum.InformationSource.participant": "Kunde",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "",
  "legalEntity.enum.LegalEntityType.company": "",
  "legalEntity.enum.LegalEntityType.person": "",
  "legalEntity.enum.LogLevel.all": "",
  "legalEntity.enum.LogLevel.debug": "",
  "legalEntity.enum.LogLevel.error": "",
  "legalEntity.enum.LogLevel.info": "",
  "legalEntity.enum.LogLevel.off": "",
  "legalEntity.enum.LogLevel.trace": "",
  "legalEntity.enum.LogLevel.warn": "",
  "legalEntity.enum.MetaAssociationOutput.aggregation": "",
  "legalEntity.enum.MetaAssociationOutput.composition": "",
  "legalEntity.enum.MetaCardinalityOutput.many": "",
  "legalEntity.enum.MetaCardinalityOutput.one": "",
  "legalEntity.enum.PartnershipType.cohabitant": "Sambo",
  "legalEntity.enum.PartnershipType.married": "Gift",
  "legalEntity.enum.PartnershipType.registeredPartnership": "Registreret partnerskab",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.cohabitant": "",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.married": "",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.registeredPartnership": "",
  "legalEntity.enum.PiiTextType.unspecified": "",
  "legalEntity.enum.PostingTable.BP": "",
  "legalEntity.enum.PostingTable.OPP": "",
  "legalEntity.enum.PostingType.glRounding": "",
  "legalEntity.enum.PostingType.glRoundingExcluded": "",
  "legalEntity.enum.PostingType.none": "Ingen",
  "legalEntity.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "",
  "legalEntity.enum.RegistrySubscriptionLevel.none": "Ingen",
  "legalEntity.enum.RegistrySubscriptionLevel.onDemand": "",
  "legalEntity.enum.RegistrySubscriptionRoleType.unspecified": "",
  "legalEntity.enum.ReportType.none": "Ingen",
  "legalEntity.enum.ReportType.personRegistrySubscription": "",
  "legalEntity.enum.ReportingEventType.cancelled": "",
  "legalEntity.enum.ReportingEventType.newReport": "",
  "legalEntity.enum.ReportingEventType.reported": "",
  "legalEntity.enum.ReportingEventType.update": "",
  "legalEntity.enum.TestBatchSpecificationType.faulty": "",
  "legalEntity.enum.TestBatchSpecificationType.noop": "",
  "legalEntity.enum.TestBatchSpecificationType.normal": "",
  "legalEntity.enum.TransitExternalPayloadStatus.failed": "",
  "legalEntity.enum.TransitExternalPayloadStatus.modified": "",
  "legalEntity.enum.TransitExternalPayloadStatus.received": "",
  "life.enum.AccountType.billing": "Fakturering",
  "life.enum.AccountType.billingRequest": "Faktureringanmodning",
  "life.enum.AccountType.billingRequestCounter": "Faktureringanmodningssekvensnummer",
  "life.enum.AccountType.claim": "Krav",
  "life.enum.AccountType.fromMoneyOutShadow": "Fra MoneyOut skyggekonto",
  "life.enum.AccountType.layerReserve": "Grundlagsreserve",
  "life.enum.AccountType.moneyIn": "MoneyIn",
  "life.enum.AccountType.moneyInShadow": "MoneyIn skyggekonto",
  "life.enum.AccountType.moneyOut": "MoneyOut",
  "life.enum.AccountType.moneyOutShadow": "MoneyOut skyggeskonto",
  "life.enum.AccountType.none": "Ingen",
  "life.enum.AccountType.payloadIn": "Payload ind",
  "life.enum.AccountType.payloadRejected": "Payload afvist",
  "life.enum.AccountType.payloadShadow": "Payload skyggekonto",
  "life.enum.AccountType.policyMoneyIn": "Indbetalingskonto",
  "life.enum.AccountType.rounding": "",
  "life.enum.AccountType.savings": "Opsparing",
  "life.enum.AccountType.sentToUnitlink": "Sendt til UnitLink",
  "life.enum.AccountType.toMoneyIn": "Til MoneyIn",
  "life.enum.AccountType.toMoneyInShadow": "Til MoneyIn skyggekonto",
  "life.enum.AccountType.toMoneyOut": "Til MoneyOut",
  "life.enum.AccountType.toUnitLinkOut": "Til UnitLink ud",
  "life.enum.AccountType.toUnitLinkOutShadow": "Til UnitLink ud skyggekonto",
  "life.enum.AccountType.unitLinkIn": "UnitLink ind",
  "life.enum.AccountType.unitLinkInShadow": "UnitLink ind skyggekonto",
  "life.enum.AccountType.unitLinkOut": "UnitLink ud",
  "life.enum.AccountType.unitLinkOutCounter": "UnitLink ud sekvensnummer",
  "life.enum.BatchStatusType.completed": "Fuldført",
  "life.enum.BatchStatusType.created": "Oprettet",
  "life.enum.BatchStatusType.failed": "Fejlet",
  "life.enum.BatchStatusType.started": "Startet",
  "life.enum.BatchStatusType.stopped": "Stoppet",
  "life.enum.BillingChannel.bS": "",
  "life.enum.BillingFrequency.halfyear": "Halvårligt",
  "life.enum.BillingFrequency.month": "Månedligt",
  "life.enum.BillingFrequency.quarter": "Kvartalsvis",
  "life.enum.BillingFrequency.year": "Årligt",
  "life.enum.BulkDataType.Accounts": "",
  "life.enum.BulkDataType.BalancePostings": "",
  "life.enum.BulkDataType.Enums": "",
  "life.enum.BulkDataType.OpenPostPostings": "",
  "life.enum.BulkDataType.ParameterValueIntervals": "",
  "life.enum.BulkDataType.ParameterValues": "",
  "life.enum.BulkDataType.TariffTemplates": "",
  "life.enum.BulkDataType.Tenants": "",
  "life.enum.BulkDataType.WorkPads": "",
  "life.enum.BusinessType.company": "",
  "life.enum.BusinessType.person": "",
  "life.enum.CommandGroupType.advance": "",
  "life.enum.CommandGroupType.annotation": "",
  "life.enum.CommandGroupType.calculation": "",
  "life.enum.CommandGroupType.employerAgreement": "",
  "life.enum.CommandGroupType.employment": "",
  "life.enum.CommandGroupType.legalEntity": "",
  "life.enum.CommandGroupType.moneyIn": "",
  "life.enum.CommandGroupType.moneyOut": "",
  "life.enum.CommandGroupType.none": "Ingen",
  "life.enum.CommandGroupType.policyChange": "",
  "life.enum.CommandGroupType.posting": "",
  "life.enum.CommandGroupType.tax": "",
  "life.enum.CommandGroupType.unitlink": "",
  "life.enum.CommandType.addAccessGroupAnnotation": "Tilføj adgangsgruppeannotering",
  "life.enum.CommandType.addBalancePostings": "Tilføj balanceposteringer",
  "life.enum.CommandType.addManualPayment": "Håndter manuel betaling",
  "life.enum.CommandType.amendAccessGroupAnnotation": "Ændr adgangsgruppeannotering",
  "life.enum.CommandType.amendCoversSelection": "Håndter ændring af dækninger",
  "life.enum.CommandType.amendEmployerAgreement": "Ændring af aftale",
  "life.enum.CommandType.amendEmployerAgreementCovers": "Ændring af dækninger",
  "life.enum.CommandType.amendEmployerAgreementPolicies": "Ændring af policer",
  "life.enum.CommandType.changeAgreement": "Ændring af aftale",
  "life.enum.CommandType.changeCommitmentAndState": "Opdater engagement manuelt",
  "life.enum.CommandType.changeCommitmentTemplateSource": "Skift kilde til engagementskabelon",
  "life.enum.CommandType.changeContributionData": "Skift bidragsdata",
  "life.enum.CommandType.changeName": "Rediger navn",
  "life.enum.CommandType.changeTaxExemption": "Skattefritagelse",
  "life.enum.CommandType.changeTemplateSource": "Rediger kilde til skabelon",
  "life.enum.CommandType.createAgreement": "Opret aftale",
  "life.enum.CommandType.deathClaim": "Dødskrav",
  "life.enum.CommandType.deathClaimOrphan": "Waisenkrav",
  "life.enum.CommandType.defaultTemplate": "Standard skabelon",
  "life.enum.CommandType.employerAgreementRollback": "Arbejdsgiverordning tilbagerulning",
  "life.enum.CommandType.employment": "Ansættelse",
  "life.enum.CommandType.employmentContribution": "Ansættlse bidrag",
  "life.enum.CommandType.employmentEnd": "Afslut ansættelse",
  "life.enum.CommandType.employmentPosting": "Ansættelsespostering",
  "life.enum.CommandType.employmentStart": "Ansættelse start",
  "life.enum.CommandType.employmentUpdate": "Ansættelse opdatering",
  "life.enum.CommandType.handleMoneyIn": "Håndter indbetaling",
  "life.enum.CommandType.handleMoneyInBillingPayment": "Håndter opkrævning",
  "life.enum.CommandType.handleUnitlinkBalance": "Håndter UnitLink balance",
  "life.enum.CommandType.handleUnitlinkClosedPortfolio": "Håndter UnitLink luk portefølje",
  "life.enum.CommandType.handleUnitlinkYield": "Håndter UnitLink afkast",
  "life.enum.CommandType.insuredPersonState": "Ændring af forsikredes tilstand",
  "life.enum.CommandType.internalCoverTransfer": "Intern overførelse af dækning",
  "life.enum.CommandType.internalTransfer": "Intern overførelse",
  "life.enum.CommandType.newCommitment": "Nyt engagement",
  "life.enum.CommandType.newPolicy": "Ny police",
  "life.enum.CommandType.pretendAddInsured": "Simulér tilføjelse af forsikret",
  "life.enum.CommandType.pretendDeath": "Simulér død",
  "life.enum.CommandType.prognosisHandleMoneyIn": "Prognose håndtering af indbetaling",
  "life.enum.CommandType.prognosisHandleMoneyInBillingPayment": "Prognose håndtering af opkrævninger",
  "life.enum.CommandType.projectionJump": "Projektion spring",
  "life.enum.CommandType.projectionStart": "Start projektion",
  "life.enum.CommandType.relatedPersonState": "Relateret person tilstand",
  "life.enum.CommandType.relatedPersonStateSimulation": "Simulering af tilstand hos relateret person",
  "life.enum.CommandType.removeAccessGroupAnnotation": "Fjern adgangsannotering",
  "life.enum.CommandType.retirement": "Pensionering",
  "life.enum.CommandType.rollback": "Tilbagerulning",
  "life.enum.CommandType.simulateTo": "Simulér til",
  "life.enum.CommandType.transformCover": "Transformer dækning",
  "life.enum.CommandType.valueTransferOut": "Overførsel ud",
  "life.enum.CommitmentStatus.contribution": "Betalende",
  "life.enum.CommitmentStatus.death": "Død",
  "life.enum.CommitmentStatus.deathRegistered": "Død registreret",
  "life.enum.CommitmentStatus.disabled": "Invalid",
  "life.enum.CommitmentStatus.disbursement": "Udbetalende",
  "life.enum.CommitmentStatus.paidUp": "Hvilende",
  "life.enum.CommitmentStatus.partialDisabled": "Delvist invalid",
  "life.enum.CommitmentStatus.partialRetired": "Delvist pensioneret",
  "life.enum.CommitmentStatus.premiumHoliday": "Henstand",
  "life.enum.CommitmentStatus.retired": "Pensioneret",
  "life.enum.CommitmentStatus.terminated": "Ophørt",
  "life.enum.CommitmentStatus.unknown": "Ukendt",
  "life.enum.CommitmentStatus.voluntaryContribution": "Frivillig betalende",
  "life.enum.ConfigurationEntityType.EnumDefinition": "",
  "life.enum.ConfigurationEntityType.EnumLiteral": "",
  "life.enum.ConfigurationEntityType.GlMap": "",
  "life.enum.ConfigurationEntityType.ParameterDefinition": "",
  "life.enum.ConfigurationEntityType.ParameterValue": "",
  "life.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "life.enum.ConfigurationEntityType.RegisteredTenant": "",
  "life.enum.ConfigurationEntityType.Template": "",
  "life.enum.CoverProductType.none": "Ingen",
  "life.enum.CoverStatus.contribution": "Betalende",
  "life.enum.CoverStatus.disbursement": "Udbetalende",
  "life.enum.CoverStatus.paidUp": "Hvilende",
  "life.enum.CoverStatus.terminated": "Afsluttet",
  "life.enum.DataSubscriptionRoleType.unspecified": "",
  "life.enum.EditType.create": "",
  "life.enum.EditType.delete": "",
  "life.enum.EditType.update": "",
  "life.enum.EmployerAgreementEndType.none": "Ingen",
  "life.enum.EmployerAgreementStatus.active": "Aktiv",
  "life.enum.EmployerAgreementStatus.future": "Fremtidig",
  "life.enum.EmployerAgreementStatus.terminated": "Ophørt",
  "life.enum.EmployerAgreementType.none": "Ingen",
  "life.enum.ExternalPayloadProcessStatusType.deleted": "",
  "life.enum.ExternalPayloadProcessStatusType.processed": "",
  "life.enum.ExternalPayloadProcessStatusType.registered": "",
  "life.enum.ExternalPayloadProcessStatusType.rejected": "",
  "life.enum.ExternalPayloadProcessStatusType.sent": "",
  "life.enum.ExternalPayloadProcessStatusType.unsent": "",
  "life.enum.ExternalPayloadReceiver.collcalc": "",
  "life.enum.ExternalPayloadReceiver.datamart2": "",
  "life.enum.ExternalPayloadReceiver.external": "",
  "life.enum.ExternalPayloadReceiver.legalentity": "",
  "life.enum.ExternalPayloadReceiver.life": "",
  "life.enum.ExternalPayloadReceiver.moneyin": "",
  "life.enum.ExternalPayloadReceiver.moneyout": "",
  "life.enum.ExternalPayloadReceiver.unitlink": "",
  "life.enum.ExternalPayloadType.bulkDataExport": "",
  "life.enum.ExternalPayloadType.camt53": "",
  "life.enum.ExternalPayloadType.camt53Returns": "",
  "life.enum.ExternalPayloadType.camt54": "",
  "life.enum.ExternalPayloadType.generalLedger": "",
  "life.enum.ExternalPayloadType.migration": "",
  "life.enum.ExternalPayloadType.namingResponse": "",
  "life.enum.ExternalPayloadType.none": "Ingen",
  "life.enum.ExternalPayloadType.pain001": "",
  "life.enum.ExternalPayloadType.pain002": "",
  "life.enum.ExternalPayloadType.testTransactionalIn": "",
  "life.enum.ExternalPayloadType.testTransactionalOut": "",
  "life.enum.ExternalPayloadType.testin": "",
  "life.enum.ExternalPayloadType.testout": "",
  "life.enum.FPlusCompletionItemTag.deprecated": "",
  "life.enum.FrameCardinality.one": "",
  "life.enum.FrameCardinality.oneToMany": "",
  "life.enum.FrameCardinality.zeroToMany": "",
  "life.enum.FrameCardinality.zeroToOne": "",
  "life.enum.Gender.Female": "Kvinde",
  "life.enum.Gender.Male": "Mand",
  "life.enum.Gender.Unknown": "Ukendt",
  "life.enum.GlAggregationType.correction": "",
  "life.enum.GlAggregationType.counter": "",
  "life.enum.GlAggregationType.manual": "",
  "life.enum.GlAggregationType.normal": "",
  "life.enum.LifeInsuranceEvent.accident": "Ulykke",
  "life.enum.LifeInsuranceEvent.criticalIllness": "Kritisk sygdom",
  "life.enum.LifeInsuranceEvent.death": "Dødsfald",
  "life.enum.LifeInsuranceEvent.deathOfRelated": "Pårørende dødsfald",
  "life.enum.LifeInsuranceEvent.disability": "Invaliditet",
  "life.enum.LifeInsuranceEvent.divorce": "Skilsmisse",
  "life.enum.LifeInsuranceEvent.lossOfLicense": "Faginvaliditet",
  "life.enum.LifeInsuranceEvent.paidUp": "Hvilende",
  "life.enum.LifeInsuranceEvent.premiumHoliday": "Henstand",
  "life.enum.LifeInsuranceEvent.retirement": "Pensionering",
  "life.enum.LifeInsuranceEvent.surrender": "Genkøb",
  "life.enum.LifeInsuranceEvent.transferOut": "Overførsel ud",
  "life.enum.LifeInsuranceEvent.transferOutDivorce": "Skilsmisseudbetaling",
  "life.enum.LifeInsuranceEvent.voluntaryContinuation": "Frivillig fortsættelse",
  "life.enum.LogLevel.all": "",
  "life.enum.LogLevel.debug": "",
  "life.enum.LogLevel.error": "",
  "life.enum.LogLevel.info": "",
  "life.enum.LogLevel.off": "",
  "life.enum.LogLevel.trace": "",
  "life.enum.LogLevel.warn": "",
  "life.enum.MetaAssociationOutput.aggregation": "",
  "life.enum.MetaAssociationOutput.composition": "",
  "life.enum.MetaCardinalityOutput.many": "",
  "life.enum.MetaCardinalityOutput.one": "",
  "life.enum.MoneyInTaxcode.none": "-",
  "life.enum.MoneyOutPeriodDuration.halfYearly": "Halvårligt",
  "life.enum.MoneyOutPeriodDuration.monthly": "Månedligt",
  "life.enum.MoneyOutPeriodDuration.quarterly": "Kvartalsvis",
  "life.enum.MoneyOutPeriodDuration.single": "Indskud",
  "life.enum.MoneyOutPeriodDuration.yearly": "Årlig",
  "life.enum.MoneyOutTaxcode.none": "Ingen",
  "life.enum.MoneyOutType.adhoc": "Ad hoc",
  "life.enum.MoneyOutType.annuity": "Løbende",
  "life.enum.MoneyOutType.lumpsum": "Engangssum",
  "life.enum.MoneyOutType.wop": "Præmiefritagelse",
  "life.enum.MoneyPeriodType.benefit": "",
  "life.enum.MoneyPeriodType.saving": "",
  "life.enum.NotificationType.alert": "",
  "life.enum.NotificationType.info": "",
  "life.enum.NotificationType.warning": "",
  "life.enum.PartnershipType.cohabitant": "Samboende",
  "life.enum.PartnershipType.married": "Gift",
  "life.enum.PartnershipType.registeredPartnership": "Registreret partnerskab",
  "life.enum.PolicyCreateType.deathTransformation": "Dødsfald",
  "life.enum.PolicyCreateType.disabilityTransformation": "Invaliditet",
  "life.enum.PolicyCreateType.incomingPayment": "Indbetaling modtaget",
  "life.enum.PolicyCreateType.incomingTransfer": "Overførsel ind",
  "life.enum.PolicyCreateType.manual": "Manuel",
  "life.enum.PolicyCreateType.retirementTransformation": "Pensionering",
  "life.enum.PolicyProductType.none": "Ingen",
  "life.enum.PolicyStatus.contribution": "Betalende",
  "life.enum.PolicyStatus.death": "Død",
  "life.enum.PolicyStatus.disabled": "Invalid",
  "life.enum.PolicyStatus.disbursement": "Udbetalende",
  "life.enum.PolicyStatus.none": "Ingen",
  "life.enum.PolicyStatus.paidUp": "Hvilende",
  "life.enum.PolicyStatus.premiumHoliday": "Henstand",
  "life.enum.PolicyStatus.retired": "Pensioneret",
  "life.enum.PolicyStatus.surrended": "Tilbagekøbt",
  "life.enum.PolicyStatus.terminated": "Ophørt",
  "life.enum.PolicyTerminateType.death": "",
  "life.enum.PolicyTerminateType.merge": "",
  "life.enum.PolicyTerminateType.outgoingTransfer": "",
  "life.enum.PolicyTerminateType.policyEnd": "",
  "life.enum.PolicyTerminateType.retirement": "",
  "life.enum.PolicyTerminateType.surrender": "",
  "life.enum.PostingTable.BP": "BP",
  "life.enum.PostingTable.OPP": "OPP",
  "life.enum.PostingType.balanceFromUnitlink": "Balance fra UnitLink",
  "life.enum.PostingType.balanceToUnitLink": "Balance til UnitLink",
  "life.enum.PostingType.billing": "Indbetaling",
  "life.enum.PostingType.billingRequest": "Opkrævningsforespørgsel",
  "life.enum.PostingType.closeSubPortfolio": "Luk dækninger",
  "life.enum.PostingType.costFromUnitLink": "Omkostninger fra UnitLink",
  "life.enum.PostingType.coverTransferredToUnitLinkCounterpost": "Dækning overført til UnitLink modpostering",
  "life.enum.PostingType.coverTransferredToUnitLinkWithNoTradeCosts": "Dækning overført til UnitLink uden handelsomkostninger",
  "life.enum.PostingType.coverTransferrredToUnitLink": "Dækning overført til UnitLink",
  "life.enum.PostingType.employmentIn": "Ansættelse ind",
  "life.enum.PostingType.endEmploymentToUnitlink": "Afslut ansættelse til UnitLink",
  "life.enum.PostingType.fixSentToUnitlinkFromState": "Ret sendt til UnitLink fra tilstand",
  "life.enum.PostingType.fundCostFromUnitlink": "Fondsomkostning fra UnitLink",
  "life.enum.PostingType.glRounding": "Regnskabsafrunding",
  "life.enum.PostingType.glRoundingExcluded": "Regnskabsafrunding ekskluderet",
  "life.enum.PostingType.internalBalanceTransfer": "Intern balance overførsel",
  "life.enum.PostingType.internalTransferBetweenCommitments": "Intern overførsel",
  "life.enum.PostingType.internalTransferBetweenDims": "Intern overførsel",
  "life.enum.PostingType.migrationBalance": "Migreringsbalance",
  "life.enum.PostingType.moneyIn": "Indbetaling",
  "life.enum.PostingType.moneyOut": "Udbetaling",
  "life.enum.PostingType.moneyOutNoProofOfLife": "Udbetaling uden livstegn",
  "life.enum.PostingType.moneyOutNoSignOfLife": "Udbetaling uden livstegn",
  "life.enum.PostingType.moveBalanceFromUnitLink": "Overfør balance fra UnitLink",
  "life.enum.PostingType.moveBalanceNotInvestedToUnitLink": "",
  "life.enum.PostingType.moveBalanceToUnitLink": "Flyt balance til UnitLink",
  "life.enum.PostingType.newCoverToUnitLink": "Ny dækning til UnitLink",
  "life.enum.PostingType.none": "Ingen",
  "life.enum.PostingType.payloadRejected": "Payload afvist",
  "life.enum.PostingType.receivedInternalTransferBetweenCommitments": "Modtaget intern overførsel mellem engagementer",
  "life.enum.PostingType.requestBalanceUpdate": "Balanceopdatering fra UnitLink",
  "life.enum.PostingType.reserveJumpDeath": "Reservespring død",
  "life.enum.PostingType.reserveJumpDisability": "Reservespring invaliditet",
  "life.enum.PostingType.revertSendEndEmploymentToUnitLink": "Tilbagefør afslutning af ansættelse til UnitLink",
  "life.enum.PostingType.revertSendMoveBalanceToUnitLink": "Tilbagefør balance til UnitLink",
  "life.enum.PostingType.revertSendNewCoverToUnitLink": "Tilbagefør ny dækning til UnitLink",
  "life.enum.PostingType.revertSendStartEmploymentToUnitLink": "Tilbagefør start af ansættelse til UnitLink",
  "life.enum.PostingType.revertSendUnitLinkSubPortfolioClose": "Tilbagefør lukning af UnitLink dækninger",
  "life.enum.PostingType.riskPremiumDeath": "Risikopræmie død",
  "life.enum.PostingType.riskPrmSurvival": "Ordinær overlevelsesgevinst",
  "life.enum.PostingType.rounding": "Afrunding",
  "life.enum.PostingType.sendBalanceToUnitLink": "Overfør balance til UnitLink",
  "life.enum.PostingType.sendEndEmploymentToUnitLink": "Send afslut ansættelse til UnitLink",
  "life.enum.PostingType.sendMoveBalanceNotInvestedToUnitLink": "",
  "life.enum.PostingType.sendMoveBalanceToUnitLink": "Flyt balance til UnitLink",
  "life.enum.PostingType.sendNewCoverToUnitLink": "Send ny dækning til UnitLink",
  "life.enum.PostingType.sendStartEmploymentToUnitLink": "Send start ansættelse til UnitLink",
  "life.enum.PostingType.sendUnitLinkSubPortfolioClose": "Overfør lukning af UnitLink dækninger",
  "life.enum.PostingType.sentInternalTransferBetweenCommitments": "Intern overførsel mellem engagementer sendt",
  "life.enum.PostingType.sentMoneyOut": "Udbetaling sendt",
  "life.enum.PostingType.sentValueTransferOut": "Overførsel ud sendt",
  "life.enum.PostingType.startEmploymentToUnitLink": "Start ansættelse til UnitLink",
  "life.enum.PostingType.tradeCostFromUnitlink": "Handel",
  "life.enum.PostingType.transferSentToUnitlinkBetweenCovers": "Overførsel sendt til UnitLink mellem dækninger",
  "life.enum.PostingType.unitLinkSubPortfolioClose": "Luk UnitLink dækninger",
  "life.enum.PostingType.usedValueTransferIn": "Anvendt overførsel ind",
  "life.enum.PostingType.valuationPrmBilling": "Indbetalt præmie",
  "life.enum.PostingType.valuationResidual": "Restpræmie",
  "life.enum.PostingType.valueTransferIn": "Overførsel ind",
  "life.enum.PostingType.valueTransferOut": "Overførsel ud",
  "life.enum.PostingType.writeOff": "Afskrivning",
  "life.enum.PostingType.yield": "Afkast",
  "life.enum.PostingType.yieldAfterMoveFromUnitLink": "",
  "life.enum.PostingType.yieldFromUnitLink": "Afkast fra UnitLink",
  "life.enum.PremiumHolidayType.none": "Ingen",
  "life.enum.ProfileType.individualProfile": "Individuel profil",
  "life.enum.ProfileType.lifeCycleProfile": "Livscyklusprofil",
  "life.enum.ProjectionType.nearTimeSimulation": "",
  "life.enum.ProjectionType.none": "Ingen",
  "life.enum.RelationshipType.child": "Barn",
  "life.enum.RelationshipType.cohabitant": "Samboende",
  "life.enum.RelationshipType.none": "Ingen",
  "life.enum.RelationshipType.registeredPartner": "Registreret partner",
  "life.enum.RelationshipType.spouse": "Ægtefælle",
  "life.enum.ReportType.none": "Ingen",
  "life.enum.ReportingEventType.cancelled": "",
  "life.enum.ReportingEventType.newReport": "",
  "life.enum.ReportingEventType.reported": "",
  "life.enum.ReportingEventType.update": "",
  "life.enum.SavingsTaxcode.none": "Ingen",
  "life.enum.TenantSubGroup.none": "Ingen",
  "life.enum.TestBatchSpecificationType.faulty": "",
  "life.enum.TestBatchSpecificationType.noop": "",
  "life.enum.TestBatchSpecificationType.normal": "",
  "life.enum.UnitlinkStatus.inUnitlink": "I UnitLink",
  "life.enum.UnitlinkStatus.leavingUnitlink": "Forlader UnitLink",
  "life.enum.UnitlinkStatus.notInUnitlink": "Ikke i UnitLink",
  "life.enum.UnitlinkStatus.notInvestedInUnitlink": "Ikke investeret i UnitLink",
  "life.enum.VoluntaryContributionPlacement.none": "Ingen",
  "moneyIn.enum.AccountType.bankShadow": "Bank skyggekonto",
  "moneyIn.enum.AccountType.billedFees": "Fakturerede gebyrer",
  "moneyIn.enum.AccountType.completedInvoices": "Fuldførte fakturaer",
  "moneyIn.enum.AccountType.convertedHistoricContributions": "Konverterede historiske bidrag",
  "moneyIn.enum.AccountType.convertedShadow": "Konverteret skyggekonto",
  "moneyIn.enum.AccountType.distributedPayments": "Fordelte betalinger",
  "moneyIn.enum.AccountType.employerAssumedPayments": "Arbejdsgiver antaget betalinger",
  "moneyIn.enum.AccountType.employerBilling": "Arbejdsgiver fakturering",
  "moneyIn.enum.AccountType.employerBillingRequest": "Arbejdsgiver fakturaanmodning",
  "moneyIn.enum.AccountType.employerContributions": "Arbejdsgiver bidrag",
  "moneyIn.enum.AccountType.employerReceivables": "Arbejdsgiver tilgodehavender",
  "moneyIn.enum.AccountType.externalShadow": "Ekstern skyggekonto",
  "moneyIn.enum.AccountType.infoServiceReconcile": "Infoservice afstemning",
  "moneyIn.enum.AccountType.infoServiceReturns": "Infoservice retour",
  "moneyIn.enum.AccountType.invoiceElements": "Fakturaelementer",
  "moneyIn.enum.AccountType.invoicePayments": "Fakturabetalinger",
  "moneyIn.enum.AccountType.invoicesLifeShadow": "Fakturaer Life skyggekonto",
  "moneyIn.enum.AccountType.lifeShadow": "Life skyggekonto",
  "moneyIn.enum.AccountType.moneyOutShadow": "MoneyOut skyggekonto",
  "moneyIn.enum.AccountType.none": "Ingen",
  "moneyIn.enum.AccountType.paidFees": "Betalte gebyrer",
  "moneyIn.enum.AccountType.payments": "Betalinger",
  "moneyIn.enum.AccountType.pendingBilling": "Afventende fakturering",
  "moneyIn.enum.AccountType.pendingTransitContributions": "Afventende transitbidrag",
  "moneyIn.enum.AccountType.personBillingRequest": "Person fakturaanmodning",
  "moneyIn.enum.AccountType.personContributions": "Person bidrag",
  "moneyIn.enum.AccountType.personPrivateBillings": "Person private faktureringer",
  "moneyIn.enum.AccountType.personReceivables": "Person tilgodehavender",
  "moneyIn.enum.AccountType.receivables": "Tilgodehavender",
  "moneyIn.enum.AccountType.rounding": "",
  "moneyIn.enum.AccountType.sentBillings": "Sendte faktureringer",
  "moneyIn.enum.AccountType.toLife": "Til Life",
  "moneyIn.enum.AccountType.toMoneyOut": "Til MoneyOut",
  "moneyIn.enum.AccountType.transitContributions": "Transitbidrag",
  "moneyIn.enum.AccountType.unclaimedPayments": "Ukravede betalinger",
  "moneyIn.enum.AccountType.undistributedPayments": "Ufordelte betalinger",
  "moneyIn.enum.AccountType.undistributedReceivables": "Ufordelte tilgodehavender",
  "moneyIn.enum.AccountType.unrelatedPaymentsShadow": "Urelaterede betalinger skyggekonto",
  "moneyIn.enum.AccountType.upcomingBillings": "Kommende faktureringer",
  "moneyIn.enum.AccountType.writeOffShadow": "Afskrivning skyggekonto",
  "moneyIn.enum.BankAccountKind.Iban": "",
  "moneyIn.enum.BankAccountKind.Other": "",
  "moneyIn.enum.BatchStatusType.completed": "Oprettet",
  "moneyIn.enum.BatchStatusType.created": "Oprettet",
  "moneyIn.enum.BatchStatusType.failed": "Fejlet",
  "moneyIn.enum.BatchStatusType.started": "Startet",
  "moneyIn.enum.BatchStatusType.stopped": "Stoppet",
  "moneyIn.enum.BillingChannel.bS": "BS",
  "moneyIn.enum.BillingFrequency.halfyear": "Halvårligt",
  "moneyIn.enum.BillingFrequency.month": "Månedligt",
  "moneyIn.enum.BillingFrequency.quarter": "Kvartalsvis",
  "moneyIn.enum.BillingFrequency.year": "Årligt",
  "moneyIn.enum.BillingMethodType.none": "Ingen",
  "moneyIn.enum.BulkDataType.Accounts": "",
  "moneyIn.enum.BulkDataType.BalancePostings": "",
  "moneyIn.enum.BulkDataType.Enums": "",
  "moneyIn.enum.BulkDataType.OpenPostPostings": "",
  "moneyIn.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyIn.enum.BulkDataType.ParameterValues": "",
  "moneyIn.enum.BulkDataType.TariffTemplates": "",
  "moneyIn.enum.BulkDataType.Tenants": "",
  "moneyIn.enum.BulkDataType.WorkPads": "",
  "moneyIn.enum.BusinessType.company": "",
  "moneyIn.enum.BusinessType.person": "",
  "moneyIn.enum.CommandGroupType.advance": "",
  "moneyIn.enum.CommandGroupType.annotation": "",
  "moneyIn.enum.CommandGroupType.calculation": "",
  "moneyIn.enum.CommandGroupType.employerAgreement": "",
  "moneyIn.enum.CommandGroupType.employment": "",
  "moneyIn.enum.CommandGroupType.invoice": "",
  "moneyIn.enum.CommandGroupType.legalEntity": "",
  "moneyIn.enum.CommandGroupType.moneyIn": "",
  "moneyIn.enum.CommandGroupType.moneyOut": "",
  "moneyIn.enum.CommandGroupType.none": "Ingen",
  "moneyIn.enum.CommandGroupType.policyChange": "",
  "moneyIn.enum.CommandGroupType.posting": "",
  "moneyIn.enum.CommandGroupType.tax": "",
  "moneyIn.enum.CommandGroupType.unitlink": "",
  "moneyIn.enum.CommandType.addAccessGroupAnnotation": "Tilføj adgangsgruppeannotering",
  "moneyIn.enum.CommandType.addInvoiceToInstallmentPlan": "Tilføj faktura til afdragsordning",
  "moneyIn.enum.CommandType.addPaymentInvoice": "Tilføj betalingsfaktura",
  "moneyIn.enum.CommandType.amendAccessGroupAnnotation": "Ændr adgangsgruppeannotering",
  "moneyIn.enum.CommandType.autoPauseInvoice": "Automatisk pause faktura",
  "moneyIn.enum.CommandType.cancelInvoice": "Annuller faktura",
  "moneyIn.enum.CommandType.createInvoice": "Opret faktura",
  "moneyIn.enum.CommandType.creditPaymentInvoice": "Kredit betalingsfaktura",
  "moneyIn.enum.CommandType.defaultTemplate": "Standard skabelon",
  "moneyIn.enum.CommandType.disablePenaltiesInvoice": "Deaktiver bøder faktura",
  "moneyIn.enum.CommandType.pauseInvoice": "Faktura sat på pause",
  "moneyIn.enum.CommandType.reconcileInvoice": "Afstem faktura",
  "moneyIn.enum.CommandType.removeAccessGroupAnnotation": "Fjern adgangsgruppeannotering",
  "moneyIn.enum.CommandType.removeInvoiceFromInstallmentPlan": "Fjern faktura fra afdragsordning",
  "moneyIn.enum.CommandType.resumeInvoice": "Genoptag faktura",
  "moneyIn.enum.CommandType.resumeInvoiceWithNextOperation": "Genoptag faktura med næste operation",
  "moneyIn.enum.CommandType.triggeredPauseInvoice": "Faktura sat på pause",
  "moneyIn.enum.CommandType.withdrawPaymentInvoice": "Træk betalingsfaktura tilbage",
  "moneyIn.enum.CommandType.writeOffInvoice": "Afskriv faktura",
  "moneyIn.enum.CompanyStatus.none": "Ingen",
  "moneyIn.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyIn.enum.ConfigurationEntityType.GlMap": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyIn.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyIn.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyIn.enum.ConfigurationEntityType.Template": "",
  "moneyIn.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.deleted": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.processed": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.registered": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.rejected": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.sent": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.unsent": "",
  "moneyIn.enum.ExternalPayloadReceiver.collcalc": "",
  "moneyIn.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyIn.enum.ExternalPayloadReceiver.external": "",
  "moneyIn.enum.ExternalPayloadReceiver.legalentity": "",
  "moneyIn.enum.ExternalPayloadReceiver.life": "",
  "moneyIn.enum.ExternalPayloadReceiver.moneyin": "",
  "moneyIn.enum.ExternalPayloadReceiver.moneyout": "",
  "moneyIn.enum.ExternalPayloadReceiver.unitlink": "",
  "moneyIn.enum.ExternalPayloadType.bulkDataExport": "",
  "moneyIn.enum.ExternalPayloadType.camt53": "",
  "moneyIn.enum.ExternalPayloadType.camt53Returns": "",
  "moneyIn.enum.ExternalPayloadType.camt54": "",
  "moneyIn.enum.ExternalPayloadType.generalLedger": "",
  "moneyIn.enum.ExternalPayloadType.migration": "",
  "moneyIn.enum.ExternalPayloadType.moneyInConversion": "",
  "moneyIn.enum.ExternalPayloadType.namingResponse": "",
  "moneyIn.enum.ExternalPayloadType.netAxept": "",
  "moneyIn.enum.ExternalPayloadType.none": "Ingen",
  "moneyIn.enum.ExternalPayloadType.pain001": "",
  "moneyIn.enum.ExternalPayloadType.pain002": "",
  "moneyIn.enum.ExternalPayloadType.testTransactionalIn": "",
  "moneyIn.enum.ExternalPayloadType.testTransactionalOut": "",
  "moneyIn.enum.ExternalPayloadType.testin": "",
  "moneyIn.enum.ExternalPayloadType.testout": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.crossBorder": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.intraCompany": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.none": "Ingen",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaB2b": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaCore": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.unpaid": "",
  "moneyIn.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyIn.enum.Gender.Female": "",
  "moneyIn.enum.Gender.Male": "",
  "moneyIn.enum.Gender.Unknown": "",
  "moneyIn.enum.GlAggregationType.correction": "",
  "moneyIn.enum.GlAggregationType.counter": "",
  "moneyIn.enum.GlAggregationType.manual": "",
  "moneyIn.enum.GlAggregationType.normal": "",
  "moneyIn.enum.InvoiceBundlingPenaltyType.none": "Ingen",
  "moneyIn.enum.InvoicePayerType.Company": "",
  "moneyIn.enum.InvoicePayerType.Person": "",
  "moneyIn.enum.InvoiceStatus.billed": "Faktureret",
  "moneyIn.enum.InvoiceStatus.cancelled": "Annulleret",
  "moneyIn.enum.InvoiceStatus.created": "Oprettet",
  "moneyIn.enum.InvoiceStatus.reconciled": "Afstemt",
  "moneyIn.enum.InvoiceStatus.reminded": "Rykket",
  "moneyIn.enum.InvoiceStatus.terminated": "Afsluttet",
  "moneyIn.enum.InvoiceTerminationAction.ignore": "",
  "moneyIn.enum.InvoiceTerminationAction.reverse": "",
  "moneyIn.enum.InvoiceTerminationAction.writeOff": "",
  "moneyIn.enum.InvoiceType.installmentPlanInvoice": "Afdragsordning",
  "moneyIn.enum.InvoiceWriteOffCategory.none": "Ingen",
  "moneyIn.enum.InvoiceWriteOffType.automatic": "Automatisk",
  "moneyIn.enum.InvoiceWriteOffType.manual": "Manuel",
  "moneyIn.enum.LogLevel.all": "",
  "moneyIn.enum.LogLevel.debug": "",
  "moneyIn.enum.LogLevel.error": "",
  "moneyIn.enum.LogLevel.info": "",
  "moneyIn.enum.LogLevel.off": "",
  "moneyIn.enum.LogLevel.trace": "",
  "moneyIn.enum.LogLevel.warn": "",
  "moneyIn.enum.MetaAssociationOutput.aggregation": "",
  "moneyIn.enum.MetaAssociationOutput.composition": "",
  "moneyIn.enum.MetaCardinalityOutput.many": "",
  "moneyIn.enum.MetaCardinalityOutput.one": "",
  "moneyIn.enum.PayerMapUpdateCause.api": "",
  "moneyIn.enum.PayerMapUpdateCause.incomingPayment": "",
  "moneyIn.enum.PaymentOwnerType.company": "",
  "moneyIn.enum.PaymentOwnerType.none": "Ingen",
  "moneyIn.enum.PaymentOwnerType.person": "",
  "moneyIn.enum.PaymentReceiverType.Account": "",
  "moneyIn.enum.PaymentReceiverType.LegalEntity": "",
  "moneyIn.enum.PaymentReceiverType.PaymentSender": "",
  "moneyIn.enum.PaymentStatus.closed": "Lukket",
  "moneyIn.enum.PaymentStatus.open": "Åben",
  "moneyIn.enum.PaymentType.directDebitBatch": "Direct Debit Batch",
  "moneyIn.enum.PaymentType.unrelatedPayment": "Urelateret betaling",
  "moneyIn.enum.PostingTable.BP": "",
  "moneyIn.enum.PostingTable.OPP": "",
  "moneyIn.enum.PostingType.approvedEmployeeContribution": "Godkendt medarbejder bidrag",
  "moneyIn.enum.PostingType.approvedNetAxeptContribution": "Godkendt Netaxept bidrag",
  "moneyIn.enum.PostingType.approvedPrivateBillingPaymentEntry": "Godkendt privat fakturering betalingspost",
  "moneyIn.enum.PostingType.approvedTransitEmployeeContribution": "Godkendt transit medarbejder bidrag",
  "moneyIn.enum.PostingType.billingPaymentEntry": "Fakturering betalingspost",
  "moneyIn.enum.PostingType.cancelledBilling": "Annulleret fakturering",
  "moneyIn.enum.PostingType.cancelledPrivateBilling": "Annulleret privat fakturering",
  "moneyIn.enum.PostingType.convertedHistoricContribution": "Konverteret historisk bidrag",
  "moneyIn.enum.PostingType.directDebitInvoicePayment": "Direct debit faktura betaling",
  "moneyIn.enum.PostingType.directDebitInvoicePaymentCancellation": "Direct debit faktura betaling annullering",
  "moneyIn.enum.PostingType.directDebitPayment": "Direct debit betaling",
  "moneyIn.enum.PostingType.directDebitPaymentSpec": "Direct debit betaling specifikation",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntry": "Direct debit betaling specifikation post",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntryReconcile": "Direct debit betaling specifikation post afstemning",
  "moneyIn.enum.PostingType.directDebitPaymentSpecReconcile": "Direct debit betaling specifikation afstemning",
  "moneyIn.enum.PostingType.employeeBilling": "Medarbejder fakturering",
  "moneyIn.enum.PostingType.employeeBillingReconcile": "Medarbejder fakturering afstemning",
  "moneyIn.enum.PostingType.employeeContribution": "Medarbejder bidrag",
  "moneyIn.enum.PostingType.employeeReceivablesSpec": "Medarbejder tilgodehavende specifikation",
  "moneyIn.enum.PostingType.employeeReceivablesSpecReconcile": "Medarbejder tilgodehavende specifikation afstemning",
  "moneyIn.enum.PostingType.employerBilling": "Arbejdsgiver fakturering",
  "moneyIn.enum.PostingType.employerContribution": "Arbejdsgiver bidrag",
  "moneyIn.enum.PostingType.employerReceivablesSpec": "Arbejdsgiver tilgodehavende specifikation",
  "moneyIn.enum.PostingType.employerReceivablesSpecDistribution": "Arbejdsgiver tilgodehavende specifikation fordeling",
  "moneyIn.enum.PostingType.employerReceivablesSpecReconcile": "Arbejdsgiver tilgodehavende specifikation afstemning",
  "moneyIn.enum.PostingType.externallyHandledEmployeeContribution": "Eksternt håndteret medarbejder bidrag",
  "moneyIn.enum.PostingType.externallyHandledEmployerContribution": "Eksternt håndteret arbejdsgiver bidrag",
  "moneyIn.enum.PostingType.glRounding": "Regnskabsafrunding",
  "moneyIn.enum.PostingType.glRoundingExcluded": "Regnskabsafrunding ekskluderet",
  "moneyIn.enum.PostingType.incomingValueTransfer": "Indkommende værdioverførsel",
  "moneyIn.enum.PostingType.incomingValueTransferReconcile": "Indkommende værdioverførsel afstemning",
  "moneyIn.enum.PostingType.infoServiceContribution": "Infoservice bidrag",
  "moneyIn.enum.PostingType.infoServicePayment": "Infoservice betaling",
  "moneyIn.enum.PostingType.infoServicePaymentSpec": "Infoservice betaling specifikation",
  "moneyIn.enum.PostingType.infoServicePaymentSpecReconcile": "Infoservice betaling specifikation afstemning",
  "moneyIn.enum.PostingType.installmentPlanBilling": "Afdragsordning fakturering",
  "moneyIn.enum.PostingType.installmentPlanBillingBundled": "Afdragsordning fakturering bundtet",
  "moneyIn.enum.PostingType.invalidEmployeeReceivablesSpec": "Ugyldig medarbejder tilgodehavende specifikation",
  "moneyIn.enum.PostingType.invalidManualEmployeeReceivablesSpec": "Ugyldig manuel medarbejder tilgodehavende specifikation",
  "moneyIn.enum.PostingType.invoiceBundlingPenalty": "Faktura bundt bøde",
  "moneyIn.enum.PostingType.invoicePaymentRedistribution": "Faktura betaling omfordeling",
  "moneyIn.enum.PostingType.invoiceTermination": "Faktura afslutning",
  "moneyIn.enum.PostingType.invoiceWriteOff": "Faktura afskrivning",
  "moneyIn.enum.PostingType.manualContribution": "Manuel bidrag",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpec": "Manuel medarbejder tilgodehavende specifikation",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecDelete": "Manuel medarbejder tilgodehavende specifikation slet",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecEdit": "Manuel medarbejder tilgodehavende specifikation rediger",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecReconcile": "Manuel medarbejder tilgodehavende specifikation afstemning",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpec": "Manuel arbejdsgiver tilgodehavende specifikation",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecDistribution": "Manuel arbejdsgiver tilgodehavende specifikation fordeling",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEdit": "Manuel arbejdsgiver tilgodehavende specifikation rediger",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEditDistribution": "Manuel arbejdsgiver tilgodehavende specifikation rediger fordeling",
  "moneyIn.enum.PostingType.manualPayment": "Manuel indbetaling",
  "moneyIn.enum.PostingType.manualPaymentSpec": "Manuel betaling specifikation",
  "moneyIn.enum.PostingType.manualPaymentSpecReconcile": "Manuel betaling specifikation afstemning",
  "moneyIn.enum.PostingType.manualReturnEmployeeContribution": "Manuel retur medarbejder bidrag",
  "moneyIn.enum.PostingType.netAxeptContribution": "Netaxept bidrag",
  "moneyIn.enum.PostingType.netAxeptPayment": "Netaxept betaling",
  "moneyIn.enum.PostingType.netAxeptPaymentSpec": "Netaxept betaling specifikation",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntry": "Netaxept betaling specifikation post",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntryReconcile": "Netaxept betaling specifikation post afstemning",
  "moneyIn.enum.PostingType.netAxeptPaymentSpecReconcile": "Netaxept betaling specifikation afstemning",
  "moneyIn.enum.PostingType.none": "Ingen",
  "moneyIn.enum.PostingType.paidInvoiceBundlingPenalty": "Betalt faktura bundt bøde",
  "moneyIn.enum.PostingType.paymentCredit": "Betaling kredit",
  "moneyIn.enum.PostingType.pensionTransfer": "Pensionsoverførsel",
  "moneyIn.enum.PostingType.personPrivateBilling": "Person privat fakturering",
  "moneyIn.enum.PostingType.personPrivateBillingReconcile": "Person privat fakturering afstemning",
  "moneyIn.enum.PostingType.privateBilling": "Privat fakturering",
  "moneyIn.enum.PostingType.privateBillingPaymentEntry": "Privat fakturering betalingspost",
  "moneyIn.enum.PostingType.privateBillingReconcile": "Privat fakturering afstemning",
  "moneyIn.enum.PostingType.privateReminder": "Privat rykker",
  "moneyIn.enum.PostingType.reminderFee": "Rykkergebyr",
  "moneyIn.enum.PostingType.returnedContribution": "Returneret bidrag",
  "moneyIn.enum.PostingType.transitContributionOut": "Transit bidrag ud",
  "moneyIn.enum.PostingType.transitEmployeeContribution": "Transit medarbejder bidrag",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpec": "Transit medarbejder tilgodehavende specifikation",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpecReconcile": "Transit medarbejder tilgodehavende specifikation afstemning",
  "moneyIn.enum.PostingType.unexpectedCancelledPrivateBilling": "Uventet annulleret privat fakturering",
  "moneyIn.enum.PostingType.unknownPayment": "Ukendt betaling",
  "moneyIn.enum.PostingType.unrelatedPayment": "Urelateret betaling",
  "moneyIn.enum.PostingType.voluntaryContribution": "Frivillig bidrag",
  "moneyIn.enum.PostingType.withdrawnContribution": "Tilbagetrukket bidrag",
  "moneyIn.enum.ReportType.none": "Ingen",
  "moneyIn.enum.ReportingEventType.cancelled": "",
  "moneyIn.enum.ReportingEventType.newReport": "",
  "moneyIn.enum.ReportingEventType.reported": "",
  "moneyIn.enum.ReportingEventType.update": "",
  "moneyIn.enum.TestBatchSpecificationType.faulty": "",
  "moneyIn.enum.TestBatchSpecificationType.noop": "",
  "moneyIn.enum.TestBatchSpecificationType.normal": "",
  "moneyIn.enum.UnexpectedInvoicePaymentType.excessAmount": "",
  "moneyIn.enum.UnexpectedInvoicePaymentType.insufficientAmount": "",
  "moneyIn.enum.UnrelatedPaymentType.none": "Ingen",
  "moneyIn.enum.ValidationStatus.invalid": "Nej",
  "moneyIn.enum.ValidationStatus.unknown": "Ukendt",
  "moneyIn.enum.ValidationStatus.valid": "Ja",
  "moneyIn.enum.ValueTransferType.none": "Ingen",
  "moneyIn.enum.VoluntaryContributionPlacement.none": "Ingen",
  "moneyIn.enum.VoluntaryContributionType.oneTime": "Indskud",
  "moneyIn.enum.VoluntaryContributionType.recurring": "Løbende",
  "moneyOut.enum.AccountType.approvedPayables": "",
  "moneyOut.enum.AccountType.bankShadow": "",
  "moneyOut.enum.AccountType.convertedHistoricPayments": "",
  "moneyOut.enum.AccountType.convertedShadow": "",
  "moneyOut.enum.AccountType.externalHandlingShadow": "",
  "moneyOut.enum.AccountType.failedPayments": "",
  "moneyOut.enum.AccountType.lifeShadow": "",
  "moneyOut.enum.AccountType.moneyInShadow": "",
  "moneyOut.enum.AccountType.none": "Ingen",
  "moneyOut.enum.AccountType.payableElements": "",
  "moneyOut.enum.AccountType.paymentRegulationBalance": "",
  "moneyOut.enum.AccountType.payments": "",
  "moneyOut.enum.AccountType.pendingPayables": "",
  "moneyOut.enum.AccountType.pendingPayments": "",
  "moneyOut.enum.AccountType.rounding": "",
  "moneyOut.enum.AccountType.taxBalance": "",
  "moneyOut.enum.AccountType.toLife": "",
  "moneyOut.enum.AccountType.writeOffShadow": "",
  "moneyOut.enum.AuditLogEventType.create": "",
  "moneyOut.enum.AuditLogEventType.read": "",
  "moneyOut.enum.AuditLogEventType.update": "",
  "moneyOut.enum.BankAccountKind.Iban": "",
  "moneyOut.enum.BankAccountKind.Other": "",
  "moneyOut.enum.BatchStatusType.completed": "Færdig",
  "moneyOut.enum.BatchStatusType.created": "Oprettet",
  "moneyOut.enum.BatchStatusType.failed": "Fejlet",
  "moneyOut.enum.BatchStatusType.started": "Startet",
  "moneyOut.enum.BatchStatusType.stopped": "Stoppet",
  "moneyOut.enum.BillingChannel.bS": "",
  "moneyOut.enum.BillingFrequency.halfyear": "Halvårligt",
  "moneyOut.enum.BillingFrequency.month": "Månedligt",
  "moneyOut.enum.BillingFrequency.quarter": "Kvartalsvis",
  "moneyOut.enum.BillingFrequency.year": "Årligt",
  "moneyOut.enum.BulkDataType.Accounts": "",
  "moneyOut.enum.BulkDataType.BalancePostings": "",
  "moneyOut.enum.BulkDataType.Enums": "",
  "moneyOut.enum.BulkDataType.OpenPostPostings": "",
  "moneyOut.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyOut.enum.BulkDataType.ParameterValues": "",
  "moneyOut.enum.BulkDataType.TariffTemplates": "",
  "moneyOut.enum.BulkDataType.Tenants": "",
  "moneyOut.enum.BulkDataType.WorkPads": "",
  "moneyOut.enum.BusinessType.company": "",
  "moneyOut.enum.BusinessType.person": "",
  "moneyOut.enum.CommandGroupType.advance": "",
  "moneyOut.enum.CommandGroupType.annotation": "",
  "moneyOut.enum.CommandGroupType.calculation": "",
  "moneyOut.enum.CommandGroupType.employerAgreement": "",
  "moneyOut.enum.CommandGroupType.employment": "",
  "moneyOut.enum.CommandGroupType.legalEntity": "",
  "moneyOut.enum.CommandGroupType.moneyIn": "",
  "moneyOut.enum.CommandGroupType.moneyOut": "",
  "moneyOut.enum.CommandGroupType.none": "Ingen",
  "moneyOut.enum.CommandGroupType.policyChange": "",
  "moneyOut.enum.CommandGroupType.posting": "",
  "moneyOut.enum.CommandGroupType.tax": "",
  "moneyOut.enum.CommandGroupType.unitlink": "",
  "moneyOut.enum.CommandType.addAccessGroupAnnotation": "Tilføj adgangsgruppeannotering",
  "moneyOut.enum.CommandType.addPayableStop": "Tilføj udbetalingsstop",
  "moneyOut.enum.CommandType.addPaymentChannel": "Tilføj betalingskanal",
  "moneyOut.enum.CommandType.amendAccessGroupAnnotation": "Ændr adgangsgruppeannotering",
  "moneyOut.enum.CommandType.createPaymentReceiver": "Opret betalingsmodtager",
  "moneyOut.enum.CommandType.defaultTemplate": "Standardskabelon",
  "moneyOut.enum.CommandType.deletePayableStop": "Slet udbetalingsstop",
  "moneyOut.enum.CommandType.deletePaymentChannel": "Slet betalingskanal",
  "moneyOut.enum.CommandType.editPayableStop": "Rediger udbetalingsstop",
  "moneyOut.enum.CommandType.editPaymentChannel": "Rediger betalingskanal",
  "moneyOut.enum.CommandType.removeAccessGroupAnnotation": "Fjern adgangsgruppeannotering",
  "moneyOut.enum.CommandType.setDefaultPaymentChannel": "Sæt standard betalingskanal",
  "moneyOut.enum.CompanyStatus.none": "Ingen",
  "moneyOut.enum.Component.caseHandler": "",
  "moneyOut.enum.Component.legalEntity": "",
  "moneyOut.enum.Component.life": "",
  "moneyOut.enum.Component.moneyIn": "",
  "moneyOut.enum.Component.moneyOut": "",
  "moneyOut.enum.Component.unitlink": "",
  "moneyOut.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyOut.enum.ConfigurationEntityType.GlMap": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyOut.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyOut.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyOut.enum.ConfigurationEntityType.Template": "",
  "moneyOut.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyOut.enum.EmploymentEndCause.deathOfEmployee": "",
  "moneyOut.enum.EmploymentEndCause.standardEnd": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.deleted": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.processed": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.registered": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.rejected": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.sent": "",
  "moneyOut.enum.ExternalPayloadProcessStatusType.unsent": "",
  "moneyOut.enum.ExternalPayloadReceiver.collcalc": "",
  "moneyOut.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyOut.enum.ExternalPayloadReceiver.external": "",
  "moneyOut.enum.ExternalPayloadReceiver.legalentity": "",
  "moneyOut.enum.ExternalPayloadReceiver.life": "",
  "moneyOut.enum.ExternalPayloadReceiver.moneyin": "",
  "moneyOut.enum.ExternalPayloadReceiver.moneyout": "",
  "moneyOut.enum.ExternalPayloadReceiver.unitlink": "",
  "moneyOut.enum.ExternalPayloadType.bulkDataExport": "",
  "moneyOut.enum.ExternalPayloadType.camt53": "",
  "moneyOut.enum.ExternalPayloadType.camt53Returns": "",
  "moneyOut.enum.ExternalPayloadType.camt54": "",
  "moneyOut.enum.ExternalPayloadType.generalLedger": "",
  "moneyOut.enum.ExternalPayloadType.migration": "",
  "moneyOut.enum.ExternalPayloadType.namingResponse": "",
  "moneyOut.enum.ExternalPayloadType.none": "Ingen",
  "moneyOut.enum.ExternalPayloadType.pain001": "",
  "moneyOut.enum.ExternalPayloadType.pain002": "",
  "moneyOut.enum.ExternalPayloadType.testTransactionalIn": "",
  "moneyOut.enum.ExternalPayloadType.testTransactionalOut": "",
  "moneyOut.enum.ExternalPayloadType.testin": "",
  "moneyOut.enum.ExternalPayloadType.testout": "",
  "moneyOut.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyOut.enum.Gender.Female": "Kvinde",
  "moneyOut.enum.Gender.Male": "Mand",
  "moneyOut.enum.Gender.Unknown": "Ukendt",
  "moneyOut.enum.GlAggregationType.correction": "",
  "moneyOut.enum.GlAggregationType.counter": "",
  "moneyOut.enum.GlAggregationType.manual": "",
  "moneyOut.enum.GlAggregationType.normal": "",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "",
  "moneyOut.enum.LifeInsuranceEvent.accident": "Ulykke",
  "moneyOut.enum.LifeInsuranceEvent.criticalIllness": "Kritisk sygdom",
  "moneyOut.enum.LifeInsuranceEvent.death": "Dødsfald",
  "moneyOut.enum.LifeInsuranceEvent.deathOfRelated": "Pårørende dødsfald",
  "moneyOut.enum.LifeInsuranceEvent.disability": "Invaliditet",
  "moneyOut.enum.LifeInsuranceEvent.divorce": "Skilsmisse",
  "moneyOut.enum.LifeInsuranceEvent.lossOfLicense": "Faginvaliditet",
  "moneyOut.enum.LifeInsuranceEvent.paidUp": "Hvilende",
  "moneyOut.enum.LifeInsuranceEvent.premiumHoliday": "Henstand",
  "moneyOut.enum.LifeInsuranceEvent.retirement": "Pensionering",
  "moneyOut.enum.LifeInsuranceEvent.surrender": "Genkøb",
  "moneyOut.enum.LifeInsuranceEvent.transferOut": "Overførsel ud",
  "moneyOut.enum.LifeInsuranceEvent.transferOutDivorce": "Skilsmisseudbetaling",
  "moneyOut.enum.LifeInsuranceEvent.voluntaryContinuation": "Frivillig fortsættelse",
  "moneyOut.enum.LogLevel.all": "",
  "moneyOut.enum.LogLevel.debug": "",
  "moneyOut.enum.LogLevel.error": "",
  "moneyOut.enum.LogLevel.info": "",
  "moneyOut.enum.LogLevel.off": "",
  "moneyOut.enum.LogLevel.trace": "",
  "moneyOut.enum.LogLevel.warn": "",
  "moneyOut.enum.MetaAssociationOutput.aggregation": "",
  "moneyOut.enum.MetaAssociationOutput.composition": "",
  "moneyOut.enum.MetaCardinalityOutput.many": "",
  "moneyOut.enum.MetaCardinalityOutput.one": "",
  "moneyOut.enum.OutgoingPaymentType.lumpSum": "Engangsbeløb",
  "moneyOut.enum.OutgoingPaymentType.onAccount": "Aconto udbetaling",
  "moneyOut.enum.OutgoingPaymentType.paymentsRefund": "Tilbagebetaling",
  "moneyOut.enum.OutgoingPaymentType.recurring": "Løbende udbetaling",
  "moneyOut.enum.OutgoingPaymentType.recurringTaxFree": "Løbende udbetaling - skattefri",
  "moneyOut.enum.OutgoingPaymentType.transit": "Videresendt beløb",
  "moneyOut.enum.PartnershipType.cohabitant": "Sambo",
  "moneyOut.enum.PartnershipType.married": "Gift",
  "moneyOut.enum.PartnershipType.registeredPartnership": "Registreret partner",
  "moneyOut.enum.PayableStatus.approved": "",
  "moneyOut.enum.PayableStatus.cancelled": "",
  "moneyOut.enum.PayableStatus.pending": "",
  "moneyOut.enum.PayableStatus.processed": "",
  "moneyOut.enum.PayableStopType.lumpSum": "Engangsbeløb",
  "moneyOut.enum.PayableStopType.recurring": "Løbende udbetaling",
  "moneyOut.enum.PayableStopType.returnPayment": "Returbetaling",
  "moneyOut.enum.PayableStopType.transferOut": "Overførsel ud",
  "moneyOut.enum.PaymentChannelType.domestic": "Dansk konto",
  "moneyOut.enum.PaymentChannelType.international": "Udenlandsk konto",
  "moneyOut.enum.PaymentOriginType.employer": "",
  "moneyOut.enum.PaymentOriginType.extrabilling": "",
  "moneyOut.enum.PaymentOriginType.life": "",
  "moneyOut.enum.PaymentOriginType.transfer": "",
  "moneyOut.enum.PaymentOriginType.voluntary": "",
  "moneyOut.enum.PaymentReceiverType.Account": "",
  "moneyOut.enum.PaymentReceiverType.LegalEntity": "",
  "moneyOut.enum.PaymentReceiverType.PaymentSender": "",
  "moneyOut.enum.PaymentStatus.aborted": "Opgivet",
  "moneyOut.enum.PaymentStatus.completed": "Fuldført",
  "moneyOut.enum.PaymentStatus.failed": "Fejlet",
  "moneyOut.enum.PaymentStatus.none": "Lukket",
  "moneyOut.enum.PaymentStatus.ready": "Klar",
  "moneyOut.enum.PaymentStatus.sent": "Sendt",
  "moneyOut.enum.PaymentStopType.lumpSum": "Sum",
  "moneyOut.enum.PaymentStopType.recurring": "Løbende",
  "moneyOut.enum.PaymentStopType.returnPayment": "Retur",
  "moneyOut.enum.PaymentStopType.transferOut": "Overførsel ud",
  "moneyOut.enum.PostingTable.BP": "",
  "moneyOut.enum.PostingTable.OPP": "",
  "moneyOut.enum.PostingType.fromPaymentRegulationLumpSum": "Regulering af engangsbeløb",
  "moneyOut.enum.PostingType.fromPaymentRegulationRecurring": "Regulering af løbende betaling",
  "moneyOut.enum.PostingType.glRounding": "Regnskabsafrunding",
  "moneyOut.enum.PostingType.glRoundingExcluded": "Regnskabsafrunding ekskluderet",
  "moneyOut.enum.PostingType.netPaymentRegulation": "Netto betalingsregulering",
  "moneyOut.enum.PostingType.none": "Ingen",
  "moneyOut.enum.PostingType.onAccountPayment": "Aconto betaling",
  "moneyOut.enum.PostingType.payable": "Kreditor",
  "moneyOut.enum.PostingType.paymentRegulationLumpSum": "Betalingsregulering engangsbeløb",
  "moneyOut.enum.PostingType.paymentRegulationRecurring": "Betalingsregulering løbende",
  "moneyOut.enum.PostingType.paymentRegulationTaxFree": "Betalingsregulering skattefri",
  "moneyOut.enum.PostingType.returnedOnAccountPayment": "Returneret aconto betaling",
  "moneyOut.enum.PostingType.returnedOnAccountPaymentCost": "Returneret aconto betaling omkostning",
  "moneyOut.enum.PostingType.returnedTaxFreePayment": "Returneret skattefri betaling",
  "moneyOut.enum.PostingType.returnedTaxFreePaymentCost": "Returneret skattefri betaling omkostning",
  "moneyOut.enum.PostingType.taxFreePayable": "Skattefri kreditor",
  "moneyOut.enum.PostingType.taxFreePayment": "Skattefri betaling",
  "moneyOut.enum.PostingType.transitPayable": "Transit kreditor",
  "moneyOut.enum.PostingType.transitPayment": "Transit betaling",
  "moneyOut.enum.ProfileType.individualProfile": "",
  "moneyOut.enum.ProfileType.lifeCycleProfile": "",
  "moneyOut.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "",
  "moneyOut.enum.RegistrySubscriptionLevel.none": "Ingen",
  "moneyOut.enum.RegistrySubscriptionLevel.onDemand": "",
  "moneyOut.enum.RegistrySubscriptionRoleType.unspecified": "",
  "moneyOut.enum.ReportType.none": "Ingen",
  "moneyOut.enum.ReportingEventType.cancelled": "",
  "moneyOut.enum.ReportingEventType.newReport": "",
  "moneyOut.enum.ReportingEventType.reported": "",
  "moneyOut.enum.ReportingEventType.update": "",
  "moneyOut.enum.TestBatchSpecificationType.faulty": "",
  "moneyOut.enum.TestBatchSpecificationType.noop": "",
  "moneyOut.enum.TestBatchSpecificationType.normal": "",
  "moneyOut.enum.VoluntaryContributionPlacement.none": "Ingen",
  "moneyOut.enum.VoluntaryContributionType.oneTime": "",
  "moneyOut.enum.VoluntaryContributionType.recurring": "",
  "unitLink.enum.AccountType.correctionShadow": "",
  "unitLink.enum.AccountType.cost": "",
  "unitLink.enum.AccountType.dividendShadow": "",
  "unitLink.enum.AccountType.fromLifeShadow": "",
  "unitLink.enum.AccountType.fund": "",
  "unitLink.enum.AccountType.fundMergeShadow": "",
  "unitLink.enum.AccountType.fundReserved": "",
  "unitLink.enum.AccountType.interim": "",
  "unitLink.enum.AccountType.invested": "",
  "unitLink.enum.AccountType.investment": "",
  "unitLink.enum.AccountType.kickbackShadow": "",
  "unitLink.enum.AccountType.lifeAutoEmptyReturn": "",
  "unitLink.enum.AccountType.lifeBalanceUpdate": "",
  "unitLink.enum.AccountType.lifeClosedPortfolio": "",
  "unitLink.enum.AccountType.lifeIn": "",
  "unitLink.enum.AccountType.lifeInCounter": "",
  "unitLink.enum.AccountType.none": "Ingen",
  "unitLink.enum.AccountType.reservedUnits": "",
  "unitLink.enum.AccountType.rounding": "",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturn": "",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturnShadow": "",
  "unitLink.enum.AccountType.toLifeBalanceUpdate": "",
  "unitLink.enum.AccountType.toLifeBalanceUpdateShadow": "",
  "unitLink.enum.AccountType.toLifeClosedPortfolio": "",
  "unitLink.enum.AccountType.toLifeClosedPortfolioShadow": "",
  "unitLink.enum.AccountType.trade": "",
  "unitLink.enum.AccountType.tradeCycle": "",
  "unitLink.enum.AccountType.tradeCycleAmount": "",
  "unitLink.enum.AccountType.tradeCycleUnits": "",
  "unitLink.enum.AccountType.units": "",
  "unitLink.enum.BatchStatusType.completed": "Fuldført",
  "unitLink.enum.BatchStatusType.created": "Oprettet",
  "unitLink.enum.BatchStatusType.failed": "Fejlet",
  "unitLink.enum.BatchStatusType.started": "Startet",
  "unitLink.enum.BatchStatusType.stopped": "Stoppet",
  "unitLink.enum.BulkDataType.Accounts": "",
  "unitLink.enum.BulkDataType.BalancePostings": "",
  "unitLink.enum.BulkDataType.Enums": "",
  "unitLink.enum.BulkDataType.OpenPostPostings": "",
  "unitLink.enum.BulkDataType.ParameterValueIntervals": "",
  "unitLink.enum.BulkDataType.ParameterValues": "",
  "unitLink.enum.BulkDataType.TariffTemplates": "",
  "unitLink.enum.BulkDataType.Tenants": "",
  "unitLink.enum.BulkDataType.WorkPads": "",
  "unitLink.enum.BusinessType.company": "",
  "unitLink.enum.BusinessType.person": "",
  "unitLink.enum.CommandGroupType.advance": "",
  "unitLink.enum.CommandGroupType.annotation": "",
  "unitLink.enum.CommandGroupType.calculation": "",
  "unitLink.enum.CommandGroupType.employerAgreement": "",
  "unitLink.enum.CommandGroupType.employment": "",
  "unitLink.enum.CommandGroupType.legalEntity": "",
  "unitLink.enum.CommandGroupType.moneyIn": "",
  "unitLink.enum.CommandGroupType.moneyOut": "",
  "unitLink.enum.CommandGroupType.none": "Ingen",
  "unitLink.enum.CommandGroupType.policyChange": "",
  "unitLink.enum.CommandGroupType.posting": "",
  "unitLink.enum.CommandGroupType.tax": "",
  "unitLink.enum.CommandGroupType.unitlink": "",
  "unitLink.enum.CommandType.addAccessGroupAnnotation": "Tilføj adgangsgruppeannotering",
  "unitLink.enum.CommandType.addFundDividend": "Tilføj fond udbytte",
  "unitLink.enum.CommandType.addFundMerge": "Tilføj fusion af investeringsfonde",
  "unitLink.enum.CommandType.addPortfolioBalancePostings": "Tilføj portefølje balanceposteringer",
  "unitLink.enum.CommandType.amendAccessGroupAnnotation": "Ændr adgangsgruppeannotering",
  "unitLink.enum.CommandType.autoEmptyMove": "",
  "unitLink.enum.CommandType.changeFund": "Skift fond",
  "unitLink.enum.CommandType.closeSubPortfolio": "Luk dækninger",
  "unitLink.enum.CommandType.defaultTemplate": "Standard skabelon",
  "unitLink.enum.CommandType.editPortfolio": "Rediger portefølje",
  "unitLink.enum.CommandType.endEmployment": "Afslut ansættelse",
  "unitLink.enum.CommandType.investmentSpec": "Investering specifikation",
  "unitLink.enum.CommandType.investmentTrade": "Investering handel",
  "unitLink.enum.CommandType.moveSubPortfolio": "Flyt dækninger",
  "unitLink.enum.CommandType.newFund": "Ny fond",
  "unitLink.enum.CommandType.newSubPortfolios": "Nye dækninger",
  "unitLink.enum.CommandType.portfolioCorrection": "Portefølje korrektion",
  "unitLink.enum.CommandType.rebalance": "Genbalancering",
  "unitLink.enum.CommandType.removeAccessGroupAnnotation": "Fjern adgangsgruppeannotering",
  "unitLink.enum.CommandType.revertCloseSubPortfolio": "Fortryd lukning af dækninger",
  "unitLink.enum.CommandType.revertEndEmployment": "Fortryd afslutning af ansættelse",
  "unitLink.enum.CommandType.revertMoveSubPortfolio": "Fortryd flytning af dækninger",
  "unitLink.enum.CommandType.revertNewSubPortfolios": "Fortryd nye dækninger",
  "unitLink.enum.CommandType.revertStartEmployment": "Fortryd start ansættelse",
  "unitLink.enum.CommandType.setPortfolioOwner": "Sæt portefølje ejer",
  "unitLink.enum.CommandType.startEmployment": "Start ansættelse",
  "unitLink.enum.CommandType.switchSubPortfolioCommand": "Skift dækninger kommando",
  "unitLink.enum.CommandType.switchSubPortfolioGroupCommand": "Skift dækninger gruppe kommando",
  "unitLink.enum.CommandType.switchTrade": "Skift handel",
  "unitLink.enum.CommandType.tradeExecution": "Handelsudførelse",
  "unitLink.enum.CommandType.unitlinkConversion": "UnitLink konvertering",
  "unitLink.enum.ConfigurationEntityType.EnumDefinition": "",
  "unitLink.enum.ConfigurationEntityType.EnumLiteral": "",
  "unitLink.enum.ConfigurationEntityType.GlMap": "",
  "unitLink.enum.ConfigurationEntityType.ParameterDefinition": "",
  "unitLink.enum.ConfigurationEntityType.ParameterValue": "",
  "unitLink.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "unitLink.enum.ConfigurationEntityType.RegisteredTenant": "",
  "unitLink.enum.ConfigurationEntityType.Template": "",
  "unitLink.enum.DataSubscriptionRoleType.unspecified": "",
  "unitLink.enum.EditType.update": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.deleted": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.processed": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.registered": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.rejected": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.sent": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.unsent": "",
  "unitLink.enum.ExternalPayloadReceiver.collcalc": "",
  "unitLink.enum.ExternalPayloadReceiver.datamart2": "",
  "unitLink.enum.ExternalPayloadReceiver.external": "",
  "unitLink.enum.ExternalPayloadReceiver.legalentity": "",
  "unitLink.enum.ExternalPayloadReceiver.life": "",
  "unitLink.enum.ExternalPayloadReceiver.moneyin": "",
  "unitLink.enum.ExternalPayloadReceiver.moneyout": "",
  "unitLink.enum.ExternalPayloadReceiver.unitlink": "",
  "unitLink.enum.ExternalPayloadType.acknowledgements": "",
  "unitLink.enum.ExternalPayloadType.bulkDataExport": "",
  "unitLink.enum.ExternalPayloadType.camt53": "",
  "unitLink.enum.ExternalPayloadType.camt53Returns": "",
  "unitLink.enum.ExternalPayloadType.camt54": "",
  "unitLink.enum.ExternalPayloadType.fundPrices": "",
  "unitLink.enum.ExternalPayloadType.generalLedger": "",
  "unitLink.enum.ExternalPayloadType.migration": "",
  "unitLink.enum.ExternalPayloadType.namingResponse": "",
  "unitLink.enum.ExternalPayloadType.none": "Ingen",
  "unitLink.enum.ExternalPayloadType.orderConfirmation": "",
  "unitLink.enum.ExternalPayloadType.pain001": "",
  "unitLink.enum.ExternalPayloadType.pain002": "",
  "unitLink.enum.ExternalPayloadType.testTransactionalIn": "",
  "unitLink.enum.ExternalPayloadType.testTransactionalOut": "",
  "unitLink.enum.ExternalPayloadType.testin": "",
  "unitLink.enum.ExternalPayloadType.testout": "",
  "unitLink.enum.ExternalPayloadType.tradeOrder": "",
  "unitLink.enum.ExternalPayloadType.unitlinkConversion": "",
  "unitLink.enum.FPlusCompletionItemTag.deprecated": "",
  "unitLink.enum.FundRiskLevel.none": "Ingen",
  "unitLink.enum.Gender.Female": "",
  "unitLink.enum.Gender.Male": "",
  "unitLink.enum.Gender.Unknown": "",
  "unitLink.enum.GlAggregationType.correction": "",
  "unitLink.enum.GlAggregationType.counter": "",
  "unitLink.enum.GlAggregationType.manual": "",
  "unitLink.enum.GlAggregationType.normal": "",
  "unitLink.enum.InvestmentAllocation.active": "",
  "unitLink.enum.InvestmentAllocation.profile": "",
  "unitLink.enum.LogLevel.all": "",
  "unitLink.enum.LogLevel.debug": "",
  "unitLink.enum.LogLevel.error": "",
  "unitLink.enum.LogLevel.info": "",
  "unitLink.enum.LogLevel.off": "",
  "unitLink.enum.LogLevel.trace": "",
  "unitLink.enum.LogLevel.warn": "",
  "unitLink.enum.MetaAssociationOutput.aggregation": "",
  "unitLink.enum.MetaAssociationOutput.composition": "",
  "unitLink.enum.MetaCardinalityOutput.many": "",
  "unitLink.enum.MetaCardinalityOutput.one": "",
  "unitLink.enum.PortfolioStatementPeriod.days": "",
  "unitLink.enum.PortfolioStatementPeriod.months": "",
  "unitLink.enum.PortfolioStatementPeriod.years": "",
  "unitLink.enum.PostingTable.BP": "",
  "unitLink.enum.PostingTable.OPP": "",
  "unitLink.enum.PostingType.autoEmptyMove": "",
  "unitLink.enum.PostingType.autoEmptyMoveFromLife": "",
  "unitLink.enum.PostingType.autoEmptyReturn": "Auto tom retur",
  "unitLink.enum.PostingType.balance": "Balance",
  "unitLink.enum.PostingType.balanceUpdateFromLife": "Balanceopdatering fra Life",
  "unitLink.enum.PostingType.closeSubPortfolio": "Luk dækninger",
  "unitLink.enum.PostingType.deInvested": "Deinvestering",
  "unitLink.enum.PostingType.deltaMoveSubPortfolio": "Delta flyt dækninger",
  "unitLink.enum.PostingType.dividend": "Udbytte",
  "unitLink.enum.PostingType.endEmploymentFromLife": "Afslut ansættelse fra Life",
  "unitLink.enum.PostingType.fundCost": "Investeringsfondsomkostning",
  "unitLink.enum.PostingType.fundMerge": "Fusion af investeringsfonde",
  "unitLink.enum.PostingType.glRounding": "Regnskabsafrunding",
  "unitLink.enum.PostingType.glRoundingExcluded": "Regnskabsafrunding ekskluderet",
  "unitLink.enum.PostingType.invested": "Investeret",
  "unitLink.enum.PostingType.investedDiff": "Investeret difference",
  "unitLink.enum.PostingType.investedInternal": "Investeret internt",
  "unitLink.enum.PostingType.investmentFromLife": "Investering fra Life",
  "unitLink.enum.PostingType.kickback": "Kickback",
  "unitLink.enum.PostingType.moveSubPortfolio": "Flyt dækninger",
  "unitLink.enum.PostingType.moveSubPortfolioFromLife": "Flyt dækninger fra Life",
  "unitLink.enum.PostingType.newSubPortfolio": "Ny dækning",
  "unitLink.enum.PostingType.newSubPortfolioFromLife": "Ny dækning fra Life",
  "unitLink.enum.PostingType.none": "Ingen",
  "unitLink.enum.PostingType.revertBalanceUpdateFromLife": "Tilbagefør balanceopdatering fra Life",
  "unitLink.enum.PostingType.revertCloseSubPortfolio": "Tilbagefør lukning af dækninger",
  "unitLink.enum.PostingType.revertEndEmploymentFromLife": "Tilbagefør afslut ansættelse fra Life",
  "unitLink.enum.PostingType.revertMoveSubPortfolioFromLife": "Tilbagefør flytning af dækninger fra Life",
  "unitLink.enum.PostingType.revertNewSubPortfolioFromLife": "Tilbagefør oprettelse af dækning",
  "unitLink.enum.PostingType.revertStartEmploymentFromLife": "Tilbagefør start ansættelse fra Life",
  "unitLink.enum.PostingType.startEmploymentFromLife": "Start ansættelse fra Life",
  "unitLink.enum.PostingType.subPortfolioMove": "Flyt dækninger",
  "unitLink.enum.PostingType.tradeAmount": "Handelsbeløb",
  "unitLink.enum.PostingType.tradeAmountCorrection": "Handelsbeløbskorrektion",
  "unitLink.enum.PostingType.tradeAmountDividend": "Handelsbeløb udbytte",
  "unitLink.enum.PostingType.tradeAmountFundCost": "Handelsbeløb fondsomkostning",
  "unitLink.enum.PostingType.tradeCost": "Handelsomkostninger",
  "unitLink.enum.PostingType.tradeUnit": "Handelsenhed",
  "unitLink.enum.PostingType.tradeUnitCorrection": "Handelsenhedskorrektion",
  "unitLink.enum.PostingType.yield": "Afkast",
  "unitLink.enum.ProfileType.individualProfile": "Individuel profil",
  "unitLink.enum.ProfileType.lifeCycleProfile": "Livscyklusprofil",
  "unitLink.enum.PrognosisAssetClass.None": "Ingen",
  "unitLink.enum.ReportType.none": "Ingen",
  "unitLink.enum.ReportingEventType.cancelled": "",
  "unitLink.enum.ReportingEventType.newReport": "",
  "unitLink.enum.ReportingEventType.reported": "",
  "unitLink.enum.ReportingEventType.update": "",
  "unitLink.enum.SwitchCommandType.paymentAndSavingsDistribution": "Indbetalings- og opsparingsfordeling",
  "unitLink.enum.SwitchCommandType.paymentDistribution": "Indbetalingsfordeling",
  "unitLink.enum.SwitchCommandType.savingsDistribution": "Opsparingsfordeling",
  "unitLink.enum.TestBatchSpecificationType.faulty": "",
  "unitLink.enum.TestBatchSpecificationType.noop": "",
  "unitLink.enum.TestBatchSpecificationType.normal": "",
  "unitLink.enum.TradeCycleStatusType.aggregated": "",
  "unitLink.enum.TradeCycleStatusType.closed": "",
  "unitLink.enum.TradeCycleStatusType.completed": "",
  "unitLink.enum.TradeCycleStatusType.completelyAcknowledged": "",
  "unitLink.enum.TradeCycleStatusType.completelySent": "",
  "unitLink.enum.TradeCycleStatusType.invested": "",
  "unitLink.enum.TradeCycleStatusType.partlyAcknowledged": "",
  "unitLink.enum.TradeCycleStatusType.partlySent": "",
  "unitLink.enum.TradeCycleStatusType.somePricesReceived": "",
  "unitLink.enum.TradeCycleStatusType.started": "",
  "unitLink.enum.TradeCycleType.none": "Ingen",
})

export const dkConfiguredEnums = defineTranslations<TranslationRecord<typeof enConfiguredEnums>>()({
  "moneyIn.enum.InvoiceBundlingPenaltyType.lateDeliveryPenalty": "Sen levering",
})
